import React, { useEffect, useState, useRef, memo, useCallback } from "react";
import { Modal, Form, Input, Button, Spinner } from "reactstrap";
import QRCode from "react-qr-code";
import { Tooltip } from "react-tooltip";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import { Block } from "notiflix/build/notiflix-block-aio";
import { AxiosResponse } from "axios";
import btnHome from "../../assets/images/icons/whiteboard-menu-left-1.svg";
import item_copy from "../../assets/images/icons/whiteboard-menu-b-5-2.svg";
import lightDelete from "../../assets/images/icons/console-control-3.svg";
import lock from "../../assets/images/icons/console-12.svg";
import toTop from "../../assets/images/icons/console-control-10.svg";
import toBottom from "../../assets/images/icons/console-control-9.svg";

import leftToolClose from "../../assets/images/tool/close_left.svg";
import rightToolClose from "../../assets/images/tool/close_right.svg";
import leftToolOpen from "../../assets/images/tool/open_left.svg";
import rightToolOpen from "../../assets/images/tool/open_right.svg";

import { Portal } from "../../utils/components";

import BottomToolbar from "../../components/common/BottomToolbar";
import LayerTool from "../../components/common/LayerTool";
import ElementHide from "../../components/common/ElementHide";
import UserSettings from "../../components/common/UserSettings";
import FullScreen from "../../components/common/FullScreen";
import BoardList from "../../components/common/BoardList";
import UsersTool from "../../components/common/UsersTool";
import RecycleBin from "../../components/common/RecycleBin";
import BackgroundModule from "../../components/common/Background";
import BaseBlock from "../../components/BaseBlock";
import DrawingTool from "../../components/common/DrawingTool";
import Mask from "../../components/common/Mask";
import MaskUser from "../../components/common/MaskUser";

import {
  setAuthorization,
  getTeacherAuthToken,
  getAuthToken,
} from "../../utils/auth";
import {
  getUrlParameter,
  removeAuthTokenFromUrl,
  random,
  randomNumber,
  resizeCalculate,
} from "../../utils/actions";
import { SCALE_STATUS } from "../../constants/general";
import {
  BackgroundCategoryGetAction,
  UsernameAction,
  BoardInfoGetAction,
  BoardLastPageAction,
  BoardListGetAction,
  BoardPageCreateAction,
  BoardElementDeleteAction,
  BoardElementGroupDeleteAction,
  ImageListGetAction,
  MemberListGetAction,
  BoardPageUpdateAction,
  WorkListGetAction,
  BoardDrawDataGetAction,
  BoardDrawDataCreateAction,
  BoardDrawDataUpdateAction,
  BoardElementListCopyAction,
  BoardElementListCopyForNowPageAction,
} from "../../store/screen/actions";
import {
  BoardElementListGetRequest,
  BoardElementListGetResponse,
  BoardDrawDataGetRequest,
  BoardDrawDataGetResponse,
  BoardDrawDataCreateFormData,
  BoardDrawDataCreateResponse,
  BoardDrawDataUpdateFormData,
} from "../../store/screen/types";
import {
  screenState,
  resetboardUpdateFlag,
  setError,
  resetboardDarwDataUpdateFlag,
  boardElementListGetError,
  boardDarwDataGetError,
  boardDarwDataCreateError,
  boardDarwDataUpdateError,
  resetBoardElementsCopyFlag,
  setPasteCount,
} from "../../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { invokeAPI } from "../../store/sagas";
import zIndex from "@mui/material/styles/zIndex";

interface SelectionBox {
  startX: number;
  startY: number;
  x: number;
  y: number;
  width: number;
  height: number;
}

interface ContainerPosition {
  top?: number;
  left?: number;
  width?: number;
  height?: number;
}

const BoardPage = ({
  accessToken,
  pageToThis,
  pageUpdateLoad,
  setPageUpdateLoad,
  setBoardSchedule,

  socket,
  socketRequest,
  socketConnected,
  socketReset,
  setSocketReset,
  setChangePage,

  boardInfo,

  userList,
  setUserList,

  UserPermission,
  zoom,

  nowPage,

  boardConfig,

  hoverCard,

  leftToolShow,
  setLeftToolShow,
  rightToolShow,
  setRightToolShow,

  coverSetting,
  setCoverSetting,

  receive,
  handleReceive,
  toolScale,

  spotlightSize,
  setSpotlightSize,
  userCoverSetting,
  setUserCoverSetting,
}: any) => {
  const dispatch = useAppDispatch();
  const {
    username,
    teacherUsername,
    boardData,
    pageInfo,
    errorMsg,
    boardUpdateSuccess,
    boards,
    boardDarwDataUpdateSuccess,
    boardElementsCopySuccess,
    copyStore,
    pasteCount,
  } = useAppSelector(state => screenState(state));
  const [screenData, setScreenData] = useState<any>({
    screenHeight: 0,
    screenWidth: 0,
  });
  const [hideDraw, setHideDraw] = useState(false);
  const [canvasClear, setCanvasClear] = useState<any>("");
  const [stepState, setStepState] = useState<any>("");
  const [toolSwitch, setToolSwitch] = useState<string>("cursor");
  const [jobType, setJobType] = useState<string>("draw");
  const [drawSetting, setDrawSetting] = useState<any>({
    mode: "pencil",
    type: "line",
    color: "#111827",
    size: 9,
  });
  const [showModal, setShowModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showSettingModal, setShowSettingModal] = useState(false);
  const [showLayerModal, setShowLayerModal] = useState(false);
  const [showPageModal, setShowPageModal] = useState(false);
  const [ScaleStatus, setScaleStatus] = useState<SCALE_STATUS>(0);
  const [Scale, setScale] = useState<number>(1);
  const [selectedList, setSelectedList] = useState<any>(null);
  const [selectedZone, setSelectedZone] = useState<any>(null);
  const [boardElements, setBoardElements] = useState<any>([]);
  const [dataList, setDataList] = useState<any>([]);
  const [editId, setEditId] = useState<any>("");
  const [actionEnd, setActionEnd] = useState<any>(false);
  const [screenPage, setScreenPage] = useState<number>(0);
  const [isFullScreenMode, setIsFullScreenMode] = useState(true);
  const [addBlock, setAddBlock] = useState<boolean>(false);
  const [layerDisplay, setLayerDisplay] = useState<boolean>(true);
  const [schedule, setSchedule] = useState<any>([]);
  const [layerUpdateLoad, setLayerUpdateLoad] = useState(false);
  const [imageSchedule, setImageSchedule] = useState<any>([]);
  const [imageScheduleCount, setImageScheduleCount] = useState<any>(0);
  const [imageUploadFinish, setImageUploadFinish] = useState<boolean>(false);
  const pageInfoRef = useRef(pageInfo);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [PermissionControl, setPermissionControl] = useState(false);
  const [draw_id, setDraw_id] = useState("");
  const [drawData, setDrawData] = useState("");
  const [canCopy, setCanCopy] = useState<boolean>(true);
  const [selectionBox, setSelectionBox] = useState<SelectionBox | null>(null);
  const [selectedDivs, setSelectedDivs] = useState<any[]>([]);
  const [selectedDivsUpdated, setSelectedDivsUpdated] =
    useState<boolean>(false);
  const [containerPosition, setContainerPosition] =
    useState<ContainerPosition | null>(null);
  const parentRef = useRef<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const divRefs = useRef<Map<number, HTMLDivElement | null>>(new Map());
  const selectionBoxRef = useRef<any | null>(null);
  const [groupSelect, setGroupSelect] = useState(false);
  const toolRef = useRef<any>(null);
  const [pasteThis, setPasteThis] = useState(false);
  const [pasteGroupSelect, setPasteGroupSelect] = useState(false);
  const [AllIsOnLock, setAllIsOnLock] = useState(false);
  const [StrokeStore, setStrokeStore] = useState<any>([]);
  const [holdThisBox, setHoldThisBox] = useState<boolean>(false);
  //
  const [firstLoad, setFirstLoad] = useState<boolean>(true);
  //
  const [cursorItem, setCursorItem] = useState<any>(null);
  const cursorSetColor = useCallback(
    (color: string) => {
      if (cursorItem) {
        recolorBase64Png(cursorItem.data.src, color).then((result: any) => {
          const DATA = cursorItem.data;
          DATA.src = result;
          const update: any = { id: cursorItem.id, data: DATA };
          updateWidget(update);
          setActionEnd(true);
        });
      }
    },
    [cursorItem],
  );
  //
  const [boardShare, setBoardShare] = useState<boolean>(false);
  const toggleBoardShareModal = () => {
    setBoardShare(prev => !prev);
  };
  const handleCopy = useCallback(async (url: string) => {
    const ok = await copyText(url);
    if (ok) {
      Notify.success("已複製到剪貼簿");
    }
  }, []);
  async function copyText(text: string) {
    try {
      await navigator.clipboard.writeText(text); // 需 HTTPS（localhost 例外）
      return true;
    } catch (err) {
      return false;
    }
  }
  //
  type VisibilityMap = Record<string, boolean>;
  const [boardElementStore, setBoardElementStore] = useState<VisibilityMap>({});
  const [ComponentDisplay, setComponentDisplay] = useState<boolean>(true);
  const [StrokeDisplay, setStrokeDisplay] = useState<boolean>(true);
  // 1) 依「指定 id 清單」切換：value='toggle' 表示反轉，或直接給 true/false
  const setVisibilityByIds = (
    ids: Array<string | number>,
    value: boolean | "toggle" = "toggle",
  ) => {
    const idSet: any = new Set(ids.map(String));
    setBoardElementStore(prev => {
      const next = { ...prev };
      for (const id of idSet) {
        const curr = next[id] ?? true; // 沒有值就先視為 true
        next[id] = value === "toggle" ? !curr : value;
      }
      return next;
    });
  };

  // 2) 依「type 條件」切換：include=true 表示只套用在該 type；false 表示「非該 type」
  const setVisibilityByType = (
    type: string,
    options: { include?: boolean; value?: boolean | "toggle" } = {},
  ) => {
    const { include = true, value = "toggle" } = options;
    setBoardElementStore(prev => {
      const next = { ...prev };
      for (const el of dataList) {
        const match = include ? el.type === type : el.type !== type;
        if (match) {
          const key = String(el.id);
          const curr = next[key] ?? true;
          next[key] = value === "toggle" ? !curr : value;
        }
      }
      return next;
    });
    if (options.include) {
      setStrokeDisplay(options.value === "toggle" ? true : false);
    } else {
      setComponentDisplay(options.value === "toggle" ? true : false);
    }
  };
  //

  useEffect(() => {
    if (nowPage && firstLoad) {
      setFirstLoad(false);
    }
  }, [nowPage]);
  //

  const BoardId = getUrlParameter("board");

  const allPermissionSet = (permission: boolean) => {
    (async () => {
      const response = await socketRequest("updatePermission", {
        all: true,
        permission: permission,
      });
      // console.log(response);
    })();
  };

  const userPermissionSet = (token: string, permission: boolean) => {
    (async () => {
      const response = await socketRequest("updatePermission", {
        token: token,
        permission: permission,
      });
      // console.log(response);
    })();
  };

  useEffect(() => {
    if (socket && socketConnected && socketReset !== 1) {
      socket.off(`componentAdded_${boardInfo.id}`);
      socket.on(`componentAdded_${boardInfo.id}`, (data: any) => {
        // console.log(data);
        if (data.trigger !== username || data.trigger !== teacherUsername) {
          setDataList((preDataList: any) => {
            const newDatalist = JSON.parse(JSON.stringify(preDataList));
            newDatalist.map((item: any, index: number) => {
              return {
                ...item,
                selected: false,
                idx: index,
              };
            });
            newDatalist.push({
              ...data.component,
              idx: newDatalist.length,
              zIndex: newDatalist.length * 2,
            });

            return newDatalist;
          });
        }
      });

      socket.off(`componentDeleted_${boardInfo.id}`);
      socket.on(`componentDeleted_${boardInfo.id}`, (data: any) => {
        // console.log(data);
        if (data.trigger !== username || data.trigger !== teacherUsername) {
          setDataList((preDataList: any) => {
            const arr = Array.from(preDataList);
            if (typeof data.id === "object") {
              for (const targetId of data.id) {
                const idx = arr.findIndex((item: any) => item.id === targetId);
                if (idx !== -1) arr.splice(idx, 1);
              }
            } else {
              const idx = arr.findIndex((item: any) => item.id === data.id);
              if (idx !== -1) arr.splice(idx, 1);
            }
            arr.map((item: any, index: number) => {
              return (item.idx = index);
            });
            return arr;
          });
        }
      });

      socket.off(`widgetUpdated_${boardInfo.id}`);
      socket.on(`widgetUpdated_${boardInfo.id}`, (data: any) => {
        // console.log(data);
        if (data.trigger !== username || data.trigger !== teacherUsername) {
          const widget = data.widget;
          let spotlightUpdateDone = false;
          setDataList((prevDataList: any) =>
            prevDataList.map((item: any) => {
              if (item.id === widget.id) {
                const new_item = {
                  ...item,
                  listTitle: Object.hasOwnProperty.call(widget, "listTitle")
                    ? widget.listTitle
                    : item.listTitle,
                  baseHeight: Object.hasOwnProperty.call(widget, "baseHeight")
                    ? widget.baseHeight
                    : item.baseHeight,
                  height: Object.hasOwnProperty.call(widget, "height")
                    ? widget.height
                    : item.height,
                  width: Object.hasOwnProperty.call(widget, "width")
                    ? widget.width
                    : item.width,
                  minHeight: Object.hasOwnProperty.call(widget, "minHeight")
                    ? widget.minHeight
                    : item.minHeight,
                  minWidth: Object.hasOwnProperty.call(widget, "minWidth")
                    ? widget.minWidth
                    : item.minWidth,
                  originTop: Object.hasOwnProperty.call(widget, "top")
                    ? widget.top
                    : item.originTop,
                  originLeft: Object.hasOwnProperty.call(widget, "left")
                    ? widget.left
                    : item.originLeft,
                  zIndex: Object.hasOwnProperty.call(widget, "zIndex")
                    ? widget.zIndex
                    : item.zIndex,
                  idx: Object.hasOwnProperty.call(widget, "idx")
                    ? widget.idx
                    : item.idx,
                  spotlight: Object.hasOwnProperty.call(widget, "spotlight")
                    ? widget.spotlight
                    : item.spotlight,
                  onLock: Object.hasOwnProperty.call(widget, "onLock")
                    ? widget.onLock
                    : item.onLock,
                  display: Object.hasOwnProperty.call(widget, "display")
                    ? widget.display
                    : item.display,
                  theme: Object.hasOwnProperty.call(widget, "theme")
                    ? widget.theme
                    : item.theme,
                  data: Object.hasOwnProperty.call(widget, "data")
                    ? widget.data
                    : item.data,
                  elementData: Object.hasOwnProperty.call(data, "elementData")
                    ? data.elementData
                    : item.elementData,
                };
                if (
                  new_item.originTop !== item.originTop ||
                  new_item.originLeft !== item.originLeft
                ) {
                  new_item.positionUpdated = true;
                }
                if (
                  !spotlightUpdateDone &&
                  new_item.spotlight !== item.spotlight
                ) {
                  const root = document.getElementById("root");
                  if (root) {
                    if (root.classList.contains("spotlight")) {
                      root.classList.remove("spotlight");
                    } else {
                      root.classList.add("spotlight");
                    }
                  }
                  spotlightUpdateDone = true;
                }
                switch (item.type) {
                  case "WIDGET_RANDOM_NAME":
                    if (
                      widget?.data?.remember &&
                      item.data.remember.length !== widget.data.remember.length
                    ) {
                      new_item.data.triggered = true;
                    }
                    break;
                  case "WIDGET_TEXT":
                  case "WIDGET_READ":
                  case "WIDGET_EVENT_COUNTDOWN":
                  case "WIDGET_HYPERLINK":
                  case "WIDGET_MIND_MAP":
                    if (Object.hasOwnProperty.call(widget, "data")) {
                      new_item.data.triggered = true;
                    }
                    break;
                  case "WIDGET_CARD":
                    if (
                      Object.hasOwnProperty.call(widget, "data") &&
                      data.cardAction
                    ) {
                      new_item.data.triggered = true;
                    }
                    break;
                }

                return new_item;
              }
              return item;
            }),
          );
        }
      });

      if (username || teacherUsername) {
        socket.off(`layerDisplayChanged_${boardInfo.id}`);
        socket.on(`layerDisplayChanged_${boardInfo.id}`, (data: any) => {
          // console.log(data);
          if (data && typeof data.display !== "undefined") {
            setLayerDisplay(!data.display);
            setDataList((prevDataList: any) =>
              prevDataList.map((item: any) => {
                return { ...item, display: !data.display };
              }),
            );
          } else if (data && typeof data.display2 !== "undefined") {
            setHideDraw(!data.display2);
            setDataList((prevDataList: any) =>
              prevDataList.map((item: any) => {
                if (item.type === "WIDGET_STROKES") {
                  return { ...item, display: data.display2 };
                }
                return item;
              }),
            );
          }
        });

        socket.off(`boardUpdated_${boardInfo.id}`);
        socket.on(`boardUpdated_${boardInfo.id}`, (data: any) => {
          // console.log(data);
          if (data.boardInfoId) {
            elementListGet({
              id: data.boardInfoId,
              is_deleted: false,
              is_draw: false,
            });
            // dispatch(BoardElementListGetAction({ id: data.boardInfoId, is_deleted: false, is_draw: false }));
            dispatch(ImageListGetAction({ id: BoardId }));
          }
          if (data.boardInfoIdForDraw) {
            boardDrawDataGet({ id: data.boardInfoIdForDraw });
            // dispatch(BoardDrawDataGetAction({ id: data.boardInfoIdForDraw }));
          }
        });
      } else {
        socket.off(`boardUpdated_${boardInfo.id}`);
        socket.on(`boardUpdated_${boardInfo.id}`, (data: any) => {
          // console.log(data);
          if (data.boardInfoId) {
            elementListGet({
              id: data.boardInfoId,
              is_deleted: false,
              is_draw: false,
            });
            // dispatch(BoardElementListGetAction({ id: data.boardInfoId, is_deleted: false, is_draw: false }));
            dispatch(ImageListGetAction({ id: BoardId }));
          }
        });
      }

      if (socketReset === 2) {
        setSocketReset(0);
      }

      return () => {
        // console.log("socket off!!!");
        socket.off(`componentAdded_${boardInfo.id}`);
        socket.off(`componentDeleted_${boardInfo.id}`);
        socket.off(`widgetUpdated_${boardInfo.id}`);

        socket.off(`layerDisplayChanged_${boardInfo.id}`);
        socket.off(`boardUpdated_${boardInfo.id}`);
      };
    }
  }, [socketConnected, socketReset]);

  useEffect(() => {
    setDataList((prevDataList: any) =>
      prevDataList.map((item: any) => {
        const oldScale = item.scale;
        return {
          ...item,
          oldScale: oldScale,
          scale: Scale,
        };
      }),
    );
  }, [screenData, Scale]);

  const elementListGet = async (data: BoardElementListGetRequest) => {
    const { id, ...formData } = data;
    const response: AxiosResponse<BoardElementListGetResponse> =
      await invokeAPI({
        data: formData,
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}/api/boardElements/${id}`,
      });
    if (response.data.status === "SUCCESS") {
      setBoardElements(response.data.data);
    } else {
      dispatch(boardElementListGetError("網路連線不佳"));
    }
  };

  const boardDrawDataGet = async (data: BoardDrawDataGetRequest) => {
    const { id } = data;
    const response: AxiosResponse<BoardDrawDataGetResponse> = await invokeAPI({
      data: { is_deleted: false, is_draw: true },
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/api/boardElements/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      const Draw_obj: any = {
        id: null,
        data: null,
      };
      if (response.data.data.length !== 0) {
        Draw_obj["id"] = response.data.data[0].id;
        Draw_obj["data"] = response.data.data[0].content;
      } else {
        boardDrawDataCreate({
          id: id,
          type: "BOARD_DRAW",
          content: JSON.stringify({ draw: "", teacherScreen: 0 }),
        });
      }
      setDraw_id(Draw_obj.id);
      setDrawData(Draw_obj.data);
    } else {
      dispatch(boardDarwDataGetError("網路連線不佳"));
    }
  };

  const boardDrawDataCreate = async (data: BoardDrawDataCreateFormData) => {
    const { id, ...formData } = data;
    const response: AxiosResponse<BoardDrawDataCreateResponse> =
      await invokeAPI({
        data: formData,
        method: "POST",
        url: `${process.env.REACT_APP_API_URL}/api/createElements/${id}`,
      });
    if (response.data.status === "SUCCESS") {
      setDraw_id(response.data.data.id);
      boardDrawDataGet({ id: id });
    } else {
      dispatch(boardDarwDataCreateError("網路連線不佳"));
    }
  };

  const boardDrawDataUpdate = async (data: BoardDrawDataUpdateFormData) => {
    const { id, ...formData } = data;
    const response = await invokeAPI({
      data: formData,
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/api/updateElements/${id}`,
    });
    if (response.data.status === "SUCCESS") {
      boardDrawDataGet({ id: boardInfo.id });
      (async () => {
        const response = await socketRequest("updateBoard", {
          boardInfoIdForDraw: boardInfo.id,
        });
        // console.log(response);
      })();
    } else {
      dispatch(boardDarwDataUpdateError("網路連線不佳"));
    }
  };

  useEffect(() => {
    if (boardInfo && !firstLoad) {
      elementListGet({ id: boardInfo.id, is_deleted: false, is_draw: false });
      dispatch(ImageListGetAction({ id: BoardId }));
      // if (userBoardIdOrder.current.id === null) {
      //   userBoardIdOrder.current.id = boardInfo.id;
      //   userBoardIdOrder.current.index = 0;
      // }
      boardDrawDataGet({ id: boardInfo.id });
    }
  }, [firstLoad]);
  // }, [boards, boardInfo, firstLoad]);

  useEffect(() => {
    pageInfoRef.current = pageInfo;
  }, [pageInfo]);

  useEffect(() => {
    const newArr: any = [];
    if (boardElements.length !== 0) {
      boardElements.map((item: any, index: number) => {
        const { content, ...elementData } = item;
        const contentObj = JSON.parse(content as any);
        contentObj.id = item.id;
        contentObj.parentId = item.page_id;
        contentObj.oldScale = contentObj.scale;
        contentObj.scale = Scale;
        contentObj.top = contentObj.originTop;
        contentObj.left = contentObj.originLeft;
        contentObj.elementData = elementData;
        contentObj.spotlight = false;
        if (contentObj.type === "WIDGET_HYPERLINK") {
          if (contentObj.data.linkList.length !== 0) {
            contentObj.height =
              contentObj.height * contentObj.data.linkList.length;
          }
        } else if (contentObj.type === "WIDGET_TIMER") {
          contentObj.data = {
            Countdown: contentObj.data.Countdown,
          };
        } else if (elementData.type === "WIDGET_STOPWATCH") {
          delete contentObj.data?.Time;
          delete contentObj.data?.StartTime;
          delete contentObj.data?.Start;
          delete contentObj.data?.Laps;
        }
        newArr.push(contentObj);
      });
      newArr.sort((a: any, b: any) => a.idx - b.idx);
      setDataList(newArr);
      if (pasteThis) {
        setPasteGroupSelect(true);
      }
    }
  }, [boardElements]);

  useEffect(() => {
    if (errorMsg || boardUpdateSuccess) {
      setShowModal(false);
      setShowSettingModal(false);
      dispatch(resetboardUpdateFlag());
    }
  }, [dispatch, errorMsg, boardUpdateSuccess, boards]);

  useEffect(() => {
    if (actionEnd) {
      ComponentUpdate("action");
    }
  }, [dataList, editId, actionEnd]);

  useEffect(() => {
    const pageList = document.querySelector("#pagelist");
    if (pageList) {
      if (pageUpdateLoad) {
        Block.hourglass("#pagelist");
      } else {
        Block.remove("#pagelist", 1000);
      }
    }
  }, [pageUpdateLoad]);

  useEffect(() => {
    if (schedule.length !== 0) {
      const arr = Array.from(schedule);
      const item: any = arr.splice(0, 1);
      updateWidget({
        id: item[0].id,
        idx: item[0].idx,
        zIndex: item[0].zIndex,
      });
      ComponentUpdate("action");
      setSchedule(arr);
    } else {
      setLayerUpdateLoad(false);
    }
  }, [schedule]);

  useEffect(() => {
    const layerList = document.querySelector("#layerlist");
    if (layerList) {
      if (layerUpdateLoad) {
        Block.hourglass("#layerlist");
      } else {
        Block.remove("#layerlist", 1000);
      }
    }
  }, [layerUpdateLoad]);

  const ComponentUpdate = (type: string) => {
    const API_URL = process.env.REACT_APP_API_URL;
    const tempObj = dataList.find((item: any) => item.id === editId);
    if (tempObj) {
      const { elementData, ...content } = tempObj;
      if (username && username !== content?.studentName) {
        return;
      }
      content.id = "";
      content.top = content.originTop;
      content.left = content.originLeft;
      content.selected = false;
      if (elementData.type === "WIDGET_STOPWATCH") {
        if (content.width / content.height < 2) {
          content.height = content.height / 2;
          content.baseHeight = 225;
        }
      }
      fetch(`${API_URL}/api/updateElements/${editId}`, {
        method: "POST",
        headers: {
          userToken: accessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: elementData.type,
          content: JSON.stringify(content),
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != "SUCCESS") {
            throw data;
          } else {
            if (type !== "nonAction") {
              setActionEnd(false);
            }
          }
        })
        .catch(e => {
          console.log("error", e);

          dispatch(setError("元件更新失敗"));
        })
        .finally(() => {
          if (type !== "nonAction") {
            setActionEnd(false);
          }
        });
    }
  };

  const ComponentGroupUpdate = (results: any) => {
    const API_URL = process.env.REACT_APP_API_URL;
    const updateData = [];
    for (let i = 0; i < results.length; i++) {
      const tempObj = results[i];
      const { elementData, ...content } = tempObj;
      if (username && username !== content?.studentName) {
        return;
      }
      content.id = "";
      content.top = content.originTop;
      content.left = content.originLeft;
      content.selected = false;
      if (elementData.type === "WIDGET_STOPWATCH") {
        if (content.width / content.height < 2) {
          content.height = content.height / 2;
          content.baseHeight = 225;
        }
      }
      updateData.push({
        id: elementData.id,
        type: elementData.type,
        content: JSON.stringify(content),
      });
    }
    if (updateData.length !== 0) {
      fetch(`${API_URL}/api/updateElementsAll/${boardInfo.id}`, {
        method: "POST",
        headers: {
          userToken: accessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: updateData,
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != "SUCCESS") {
            throw data;
          } else {
          }
        })
        .catch(e => {
          console.log("error", e);

          dispatch(setError("元件更新失敗"));
        });
    }
  };

  const toggleModal = () => {
    setShowModal(prev => !prev);
  };

  const toggleUserModal = () => {
    setShowUserModal(prev => !prev);
  };

  const toggleSettingModal = () => {
    setShowSettingModal(prev => !prev);
  };

  const toggleLayerModal = () => {
    setShowLayerModal(prev => !prev);
  };

  const togglePageModal = () => {
    setShowPageModal(prev => !prev);
  };

  useEffect(() => {
    if (pasteThis && pasteGroupSelect) {
      const parentRect: any = parentRef.current?.getBoundingClientRect();
      const parentLeft = parentRect.left || 0;
      const parentTop = parentRect.top || 0;
      const selected = dataList
        .slice(-JSON.parse(copyStore).length)
        .map((obj: any) => obj.id);
      const selectedRefs = selected
        .map((id: any) => divRefs.current.get(id))
        .filter((ref: any) => ref !== null) as HTMLDivElement[];
      console.log("selectedRefs", dataList, selected, selectedRefs);

      if (selectedRefs && selectedRefs.length > 0) {
        const bounds = selectedRefs.reduce(
          (acc, ref) => {
            const rect = ref.getBoundingClientRect();
            return {
              top: Math.min(acc.top, rect.top),
              left: Math.min(acc.left, rect.left),
              bottom: Math.max(acc.bottom, rect.bottom),
              right: Math.max(acc.right, rect.right),
            };
          },
          {
            top: Infinity,
            left: Infinity,
            bottom: -Infinity,
            right: -Infinity,
          },
        );

        //
        if (selectedRefs.length > 1) {
          setSelectedDivs(selectedRefs);
          setContainerPosition({
            top: (bounds.top - parentTop) / zoom,
            left: (bounds.left - parentLeft) / zoom,
            width: (bounds.right - bounds.left) / zoom,
            height: (bounds.bottom - bounds.top) / zoom,
          });
          setPasteThis(false);
          setPasteGroupSelect(false);
        }
      }
    }
  }, [dataList, divRefs, pasteThis, pasteGroupSelect, parentRef.current]);

  const addDrawComponent = useCallback(
    (drawData: any, src: string, cb: any) => {
      const newData = {
        id: "",
        parentId: "",
        BoardId: BoardId,
        idx: dataList.length + StrokeStore.length,
        studentName: username,
        title: "畫筆",
        listTitle: "畫筆",
        height:
          drawData.height / Scale + (drawData.strokeWidth === 27 ? 64 : 32),
        width: drawData.width / Scale + (drawData.strokeWidth === 27 ? 64 : 32),
        minHeight: 20,
        minWidth: 20,
        baseHeight: drawData.height,
        background: "",
        zIndex: (dataList.length + StrokeStore.length) * 2,
        toTop: 1000105,
        originTop: drawData.originalY - (drawData.strokeWidth === 27 ? 32 : 16),
        originLeft:
          drawData.originalX - (drawData.strokeWidth === 27 ? 32 : 16),
        top: drawData.originalY - (drawData.strokeWidth === 27 ? 32 : 16),
        left: drawData.originalX - (drawData.strokeWidth === 27 ? 32 : 16),
        oldScale: null,
        scale: Scale,
        type: "WIDGET_STROKES",
        selected: false,
        spotlight: false,
        onLock: false,
        display: true,
        className: "widget-strokes",
        theme: "theme1",
        data: {
          src: src,
        },
        elementData: {},
      };
      const API_URL = process.env.REACT_APP_API_URL;
      fetch(`${API_URL}/api/createElements/${boardInfo!.id}`, {
        method: "POST",
        headers: {
          userToken: accessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "WIDGET_STROKES",
          content: JSON.stringify(newData),
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != "SUCCESS") {
            throw data;
          } else {
            newData.id = data.data.id;
            newData.parentId = data.data.page_id;
            newData.elementData = data.data;
            newData.selected = false;
            const newStrokeStores = JSON.parse(JSON.stringify(StrokeStore));
            newStrokeStores.push(newData);
            setStrokeStore(newStrokeStores);

            // const newDatalist = JSON.parse(JSON.stringify(dataList));
            // newDatalist.map((item: any, index: number) => {
            //   return item.selected = false;
            // })
            // newDatalist.push(newData);

            // setDataList(newDatalist);
            // setTimeout(() => {
            //   setAddBlock(false);
            // }, 500);

            if (cb) {
              cb();
            }

            (async () => {
              const response = await socketRequest("addComponent", {
                trigger: username || teacherUsername,
                boardInfoId: boardInfo.id,
                component: { ...newData },
              });
              // console.log(response);
            })();
          }
        })
        .catch(e => {
          console.log("error", e);
          dispatch(setError("元件新增失敗"));
        });
    },
    [dataList, StrokeStore],
  );

  useEffect(() => {
    if (
      StrokeStore.length !== 0 &&
      (toolSwitch === "cursor" ||
        (toolSwitch === "draw" &&
          (jobType === "grab" || jobType === "eraser" || jobType === "paint")))
    ) {
      const newDatalist = JSON.parse(JSON.stringify(dataList));
      StrokeStore.map((item: any, index: number) => {
        newDatalist.push(item);
      });
      setDataList(newDatalist);
      setStrokeStore([]);
      setTimeout(() => {
        setAddBlock(false);
      }, 500);
    }
  }, [toolSwitch, jobType, dataList, StrokeStore]);

  const addComponent = useCallback(
    (type: string) => {
      const newData = {
        id: "",
        parentId: "",
        BoardId: BoardId,
        idx: dataList.length,
        studentName: username,
        title: "",
        listTitle: "",
        height: 0,
        width: 0,
        minHeight: 0,
        minWidth: 0,
        baseHeight: 0,
        background: "",
        zIndex: dataList.length * 2,
        toTop: 1000105,
        originTop: 0,
        originLeft: 0,
        top: 0,
        left: 0,
        oldScale: null,
        scale: Scale,
        type: "",
        selected: false,
        spotlight: false,
        onLock: false,
        display: true,
        className: "",
        theme: "theme1",
        data: {},
        elementData: {},
      };

      switch (type) {
        case "WIDGET_RANDOM_NAME":
          newData.title = "抽籤";
          newData.listTitle = "抽籤";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 500;
          newData.minHeight = 150;
          newData.minWidth = 280;
          newData.background = "#fff";
          newData.originTop = 240;
          newData.originLeft = 50;
          newData.top = 240;
          newData.left = 50;
          newData.className = "widget-random-name";
          newData.data = {
            nameList: [],
            remember: [],
          };
          break;
        case "WIDGET_QR_CODE":
          newData.title = "二維碼";
          newData.listTitle = "二維碼";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 300;
          newData.minHeight = 250;
          newData.minWidth = 250;
          newData.background = "#fff";
          newData.originTop = 132;
          newData.originLeft = 492;
          newData.top = 132;
          newData.left = 492;
          newData.className = "widget-qrcode";
          newData.data = {
            codeStr: "",
            title: "",
            titleSwitch: false,
          };
          break;
        case "WIDGET_IMAGE":
          newData.title = "圖片";
          newData.listTitle = "圖片";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 400;
          newData.minHeight = 50;
          newData.minWidth = 50;
          newData.background = "";
          newData.originTop = 334;
          newData.originLeft = 96;
          newData.top = 334;
          newData.left = 96;
          newData.className = "widget-image";
          newData.data = {
            imgId: "",
            path: "",
            rotate: 0,
          };
          break;
        case "WIDGET_TEXT":
          newData.title = "寫字";
          newData.listTitle = "寫字";
          newData.type = type;
          newData.baseHeight = 400;
          newData.height = 400;
          newData.width = 650;
          newData.minHeight = 48;
          newData.minWidth = 120;
          newData.background = "#fff";
          newData.originTop = 140;
          newData.originLeft = 665;
          newData.top = 140;
          newData.left = 665;
          newData.className = "widget-text";
          newData.data = {
            content: "",
            setting: {
              fontFamily: "",
              fonSize: "",
            },
            type: "text",
            marquee: {
              content: "",
              fontSize: 20,
              direction: "right",
              speed: 1,
            },
          };
          break;
        case "WIDGET_READ":
          newData.title = "閱讀器";
          newData.listTitle = "閱讀器";
          newData.type = type;
          newData.baseHeight = 500;
          newData.height = 500;
          newData.width = 650;
          newData.minHeight = 48;
          newData.minWidth = 120;
          newData.background = "#fff";
          newData.originTop = 250;
          newData.originLeft = 600;
          newData.top = 250;
          newData.left = 600;
          newData.className = "widget-read";
          newData.data = {
            content: "",
            writing: "",
            fontSize: 32,
            fontSpace: 0,
            html: null,
          };
          break;
        case "WIDGET_TIMER":
          newData.title = "計時器";
          newData.listTitle = "計時器";
          newData.type = type;
          newData.baseHeight = 230;
          newData.height = 230;
          newData.width = 620;
          newData.minHeight = 150;
          newData.minWidth = 150;
          newData.background = "#fff";
          newData.originTop = 180;
          newData.originLeft = 1228;
          newData.top = 180;
          newData.left = 1228;
          newData.className = "widget-timer";
          newData.data = {
            Countdown: 5,
          };
          break;
        case "WIDGET_CLOCK":
          newData.title = "時鐘";
          newData.listTitle = "時鐘";
          newData.type = type;
          newData.baseHeight = 380;
          newData.height = 380;
          newData.width = 300;
          newData.minHeight = 60;
          newData.minWidth = 150;
          newData.background = "#fff";
          newData.originTop = 144;
          newData.originLeft = 1605;
          newData.top = 144;
          newData.left = 1605;
          newData.className = "widget-clock";
          newData.data = {
            time12HourFormat: true,
            time24HourFormat: false,
          };
          break;
        case "WIDGET_CALENDAR":
          newData.title = "日曆";
          newData.listTitle = "日曆";
          newData.type = type;
          newData.baseHeight = 400;
          newData.height = 400;
          newData.width = 500;
          newData.minHeight = 210;
          newData.minWidth = 140;
          newData.background = "#fff";
          newData.originTop = 422;
          newData.originLeft = 660;
          newData.top = 422;
          newData.left = 660;
          newData.className = "widget-calendar";
          newData.data = {
            Monday: true,
            Sunday: false,
          };
          break;
        case "WIDGET_TIMETABLE":
          newData.title = "時程表";
          newData.listTitle = "時程表";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 453;
          newData.minHeight = 50;
          newData.minWidth = 170;
          newData.background = "#fff";
          newData.originTop = 200;
          newData.originLeft = 590;
          newData.top = 200;
          newData.left = 590;
          newData.className = "widget-timetable";
          newData.data = {
            listTitle: "",
            listTitleShow: true,
            listType: "timetable",
            firstTime: {
              hour: 8,
              minutes: 0,
            },
            timeTable: [],
          };
          break;
        case "WIDGET_GROUP_MAKER":
          newData.title = "分組";
          newData.listTitle = "分組";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 360;
          newData.minHeight = 250;
          newData.minWidth = 250;
          newData.background = "#fff";
          newData.originTop = 150;
          newData.originLeft = 730;
          newData.top = 150;
          newData.left = 730;
          newData.className = "widget-group-maker";
          newData.data = {
            nameList: [],
            groupList: [],
            groups: 4,
            fontSize: 1,
          };
          break;
        case "WIDGET_STOPWATCH":
          newData.title = "碼錶";
          newData.listTitle = "碼錶";
          newData.type = type;
          newData.baseHeight = 225;
          newData.height = 225;
          newData.width = 465;
          newData.minHeight = 75;
          newData.minWidth = 155;
          newData.background = "#fff";
          newData.originTop = 195;
          newData.originLeft = 714;
          newData.top = 195;
          newData.left = 714;
          newData.className = "widget-stopwatch";
          newData.data = {
            Lap: true,
            Split: false,
          };
          break;
        case "WIDGET_EMBED":
          newData.title = "代碼嵌入";
          newData.listTitle = "代碼嵌入";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 533;
          newData.minHeight = 125;
          newData.minWidth = 125;
          newData.background = "#fff";
          newData.originTop = 232;
          newData.originLeft = 95;
          newData.top = 232;
          newData.left = 95;
          newData.className = "widget-embed";
          newData.data = {
            codeStr: "",
          };
          break;
        case "WIDGET_VIDEO_TIMELINE":
          newData.title = "影片";
          newData.listTitle = "影片";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 533;
          newData.minHeight = 130;
          newData.minWidth = 192;
          newData.background = "#fff";
          newData.originTop = 230;
          newData.originLeft = 1260;
          newData.top = 230;
          newData.left = 1260;
          newData.className = "widget-video-Timeline";
          newData.data = {
            codeStr: "",
            isStream: false,
            start: "",
            end: "",
          };
          break;
        case "WIDGET_EVENT_COUNTDOWN":
          newData.title = "活動倒數計時器";
          newData.listTitle = "活動倒數計時器";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 425;
          newData.minHeight = 120;
          newData.minWidth = 170;
          newData.background = "#fff";
          newData.originTop = 360;
          newData.originLeft = 586;
          newData.top = 360;
          newData.left = 586;
          newData.className = "widget-event-countdown";
          newData.data = {
            eventName: "",
            eventNameFontSize: 30,
            startDate: "",
            endDate: "",
            eventType: "",
          };
          break;
        case "WIDGET_HYPERLINK":
          newData.title = "超連結";
          newData.listTitle = "超連結";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 300;
          newData.minHeight = 45;
          newData.minWidth = 158;
          newData.background = "#fff";
          newData.originTop = 180;
          newData.originLeft = 640;
          newData.top = 180;
          newData.left = 640;
          newData.className = "widget-hyperlink";
          newData.data = {
            linkList: [],
          };
          break;
        case "WIDGET_WORKS":
          newData.title = "作業";
          newData.listTitle = "作業";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 360;
          newData.minHeight = 250;
          newData.minWidth = 250;
          newData.background = "#fff";
          newData.originTop = 150;
          newData.originLeft = 430;
          newData.top = 150;
          newData.left = 430;
          newData.className = "widget-works";
          newData.data = {
            workObj: null,
          };
          break;
        case "WIDGET_CARD":
          newData.title = "翻卡片";
          newData.listTitle = "翻卡片";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 425;
          newData.minHeight = 188;
          newData.minWidth = 320;
          newData.background = "#fff";
          newData.originTop = 460;
          newData.originLeft = 820;
          newData.top = 460;
          newData.left = 820;
          newData.className = "widget-card";
          newData.data = {
            title: "",
            cardList: [],
            deck: [],
            drawnCards: [],
            drawNow: null,
            action: "",
            start: false,
          };
          break;
        case "WIDGET_MIND_MAP":
          newData.title = "心智圖";
          newData.listTitle = "心智圖";
          newData.type = type;
          newData.baseHeight = 300;
          newData.height = 300;
          newData.width = 360;
          newData.minHeight = 250;
          newData.minWidth = 250;
          newData.background = "#fff";
          newData.originTop = 150;
          newData.originLeft = 730;
          newData.top = 150;
          newData.left = 730;
          newData.className = "widget-mind-map";
          newData.data = {
            rawData: "",
            tempData: "",
            mindMapImage: null,
            cooperate: 0,
            action: "default",
          };
          break;

        default:
          break;
      }

      const API_URL = process.env.REACT_APP_API_URL;
      fetch(`${API_URL}/api/createElements/${boardInfo!.id}`, {
        method: "POST",
        headers: {
          userToken: accessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: type,
          content: JSON.stringify(newData),
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != "SUCCESS") {
            throw data;
          } else {
            newData.id = data.data.id;
            newData.parentId = data.data.page_id;
            newData.elementData = data.data;
            newData.selected = true;

            const newDatalist = JSON.parse(JSON.stringify(dataList));
            newDatalist.map((item: any, index: number) => {
              return (item.selected = false);
            });
            newDatalist.push(newData);

            setAllIsOnLock(false);
            setContainerPosition(null);
            setSelectedDivs([]);
            setDataList(newDatalist);
            setTimeout(() => {
              setAddBlock(false);
            }, 500);

            // if (type !== "WIDGET_IMAGE") {
            (async () => {
              const response = await socketRequest("addComponent", {
                trigger: username || teacherUsername,
                boardInfoId: boardInfo.id,
                component: { ...newData },
              });
              // console.log(response);
            })();
            // }
          }
        })
        .catch(e => {
          console.log("error", e);
          dispatch(setError("元件新增失敗"));
        });
    },
    [dataList],
  );

  const removeComponent = useCallback(
    async (e: any, id: string) => {
      if (e.button === 2) {
        e.preventDefault();
        return;
      }
      const arr = Array.from(dataList);
      const index = arr.findIndex((item: any) => item.id === id);
      arr.splice(index, 1);
      dispatch(BoardElementDeleteAction({ id: id }));
      arr.map((item: any, index: number) => {
        return (item.idx = index);
      });
      setDataList(arr);
      setSchedule(arr);

      (async () => {
        const response = await socketRequest("deleteComponent", {
          trigger: username,
          boardInfoId: boardInfo.id,
          id: id,
        });
        // console.log(response);
      })();
    },
    [dataList],
  );

  const copyComponent = useCallback(
    async (item: any, copyCount: any = null) => {
      const API_URL = process.env.REACT_APP_API_URL;
      const tempObj = item;
      if (tempObj) {
        const { elementData, ...content } = tempObj;
        if (username && username !== content?.studentName) {
          return;
        }
        const newData = {
          id: "",
          parentId: "",
          BoardId: BoardId,
          idx: dataList.length,
          studentName: username,
          title: "",
          listTitle: "",
          height: 0,
          width: 0,
          minHeight: 0,
          minWidth: 0,
          baseHeight: 0,
          background: "",
          zIndex: dataList.length * 2,
          toTop: 1000105,
          originTop: 0,
          originLeft: 0,
          top: 0,
          left: 0,
          oldScale: null,
          scale: Scale,
          type: "",
          selected: false,
          spotlight: false,
          onLock: false,
          display: true,
          className: "",
          theme: "theme1",
          data: {},
          elementData: {},
        };
        newData.title = content.title;
        newData.listTitle = content.listTitle;
        newData.type = content.type;
        newData.baseHeight = content.baseHeight;
        newData.height = content.height;
        newData.width = content.width;
        newData.minHeight = content.minHeight;
        newData.minWidth = content.minWidth;
        newData.background = content.background;
        newData.originTop =
          content.originTop + 16 * (!copyCount ? pasteCount : copyCount);
        newData.originLeft =
          content.originLeft + 16 * (!copyCount ? pasteCount : copyCount);
        newData.top =
          content.originTop + 16 * (!copyCount ? pasteCount : copyCount);
        newData.left =
          content.originLeft + 16 * (!copyCount ? pasteCount : copyCount);
        newData.className = content.className;
        newData.theme = content.theme;
        newData.data = content.data;

        if (elementData.type === "WIDGET_STOPWATCH") {
          if (newData.width / newData.height < 2) {
            newData.height = newData.height / 2;
            newData.baseHeight = 225;
          }
        }
        fetch(`${API_URL}/api/createElements/${boardInfo!.id}`, {
          method: "POST",
          headers: {
            userToken: accessToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: elementData.type,
            content: JSON.stringify(newData),
          }),
        })
          .then(response => response.json())
          .then(data => {
            if (data.status != "SUCCESS") {
              throw data;
            } else {
              newData.id = data.data.id;
              newData.parentId = data.data.page_id;
              newData.elementData = data.data;
              newData.selected = true;

              const newDatalist = JSON.parse(JSON.stringify(dataList));
              newDatalist.map((item: any, index: number) => {
                return (item.selected = false);
              });
              newDatalist.push(newData);

              setAllIsOnLock(false);
              setContainerPosition(null);
              setSelectedDivs([]);
              setDataList(newDatalist);
              setTimeout(() => {
                setAddBlock(false);
              }, 500);

              (async () => {
                const response = await socketRequest("addComponent", {
                  trigger: username || teacherUsername,
                  boardInfoId: boardInfo.id,
                  component: { ...newData },
                });
                // console.log(response);
              })();
            }
          })
          .catch(e => {
            console.log("error", e);
            dispatch(setError("元件複製失敗"));
          });
      }
    },
    [dataList, pasteCount],
  );

  const addImageComponent = useCallback(
    (imageId: string, imagePath: string, count: number) => {
      const newData = {
        id: "",
        parentId: "",
        BoardId: BoardId,
        idx: dataList.length + count,
        studentName: username,
        title: "",
        listTitle: "",
        height: 0,
        width: 0,
        minHeight: 0,
        minWidth: 0,
        baseHeight: 0,
        background: "",
        zIndex: (dataList.length + count) * 2,
        toTop: 1000105,
        originTop: 0,
        originLeft: 0,
        top: 0,
        left: 0,
        oldScale: null,
        scale: Scale,
        type: "",
        selected: false,
        spotlight: false,
        onLock: false,
        display: true,
        className: "",
        theme: "theme1",
        data: {},
        elementData: {},
      };

      const { Left, Top } = calculateXY(count + 1);

      newData.title = "圖片";
      newData.listTitle = "圖片";
      newData.type = "WIDGET_IMAGE";
      newData.baseHeight = 300;
      newData.height = 300;
      newData.width = 400;
      newData.minHeight = 50;
      newData.minWidth = 50;
      newData.background = "";
      newData.originTop = Top;
      newData.originLeft = Left;
      newData.top = Top;
      newData.left = Left;
      newData.className = "widget-image";
      newData.data = {
        imgId: imageId,
        path: imagePath,
        rotate: 0,
      };

      const API_URL = process.env.REACT_APP_API_URL;
      fetch(`${API_URL}/api/createElements/${boardInfo!.id}`, {
        method: "POST",
        headers: {
          userToken: accessToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          type: "WIDGET_IMAGE",
          content: JSON.stringify(newData),
        }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != "SUCCESS") {
            throw data;
          } else {
            setAllIsOnLock(false);
            setContainerPosition(null);
            setSelectedDivs([]);
            setTimeout(() => {
              updateWidget({
                id: data.data.id,
                parentId: data.data.page_id,
                elementData: data.data,
              });
              setTimeout(() => {
                setAddBlock(false);

                if (boardInfo && imageUploadFinish) {
                  elementListGet({
                    id: boardInfo.id,
                    is_deleted: false,
                    is_draw: false,
                  });

                  (async () => {
                    const response = await socketRequest("updateBoard", {
                      boardInfoId: boardInfo.id,
                    });
                    // console.log(response);
                  })();
                }
              }, 500);
            }, 1500);
          }
        })
        .catch(e => {
          console.log("error", e);

          dispatch(setError("元件新增失敗"));
        });
    },
    [dataList, imageUploadFinish],
  );

  const callUpdateBoard = () => {
    if (boardInfo) {
      (async () => {
        const response = await socketRequest("updateBoard", {
          boardInfoId: boardInfo.id,
        });
        // console.log(response);
      })();
    }
  };

  const calculateXY = (num: number) => {
    const Left = 32 * num;
    const Top = 32 * (num % 10 === 0 ? 10 : num % 10);
    return { Left, Top };
  };

  const fileUpload = (file: any, count: number, schedule: any) => {
    if (file) {
      let token = null;
      if (getAuthToken()) {
        token = getAuthToken();
      } else if (getTeacherAuthToken()) {
        token = getTeacherAuthToken();
      }
      const headers = new Headers();
      if (token) {
        headers.append("userToken", token);
      }
      const fileFormData = new FormData();
      fileFormData.append("file", file);
      fileFormData.append("board_id", BoardId);
      fetch(`${process.env.REACT_APP_API_URL}/api/elements/uploadImages`, {
        method: "POST",
        headers: headers,
        body: fileFormData,
      })
        .then(response => response.json())
        .then(data => {
          if (data.status != "SUCCESS") {
            throw data;
          } else {
            //
            if (schedule) {
              const target = dataList.find((item: any) => item.id === editId);
              const imgData = target.data;
              imgData.imgId = data.data.id;
              imgData.path = data.data.path;
              const update: any = { id: editId, data: imgData };
              updateWidget(update);
              setActionEnd(true);

              if (boardInfo) {
                (async () => {
                  const response = await socketRequest("updateBoard", {
                    boardInfoId: boardInfo.id,
                  });
                  dispatch(ImageListGetAction({ id: BoardId }));
                  // console.log(response);
                })();
              }
            } else {
              addImageComponent(data.data.id, data.data.path, count - 2);
            }
          }
        })
        .catch(e => {
          console.log("error", e);

          dispatch(
            setError(
              "圖片上傳失敗，請再試一次。請確認檔案類型是否正確，或者檔案大小是否大於25MB",
            ),
          );
        });
    }
  };

  useEffect(() => {
    if (imageSchedule.length !== 0) {
      const arr = Array.from(imageSchedule);
      const file: any = arr.splice(0, 1);
      fileUpload(
        file[0],
        imageScheduleCount - arr.length,
        imageSchedule.length === imageScheduleCount,
      );
      setImageSchedule(arr);
    }
    if (imageSchedule.length === 0) {
      setImageUploadFinish(true);
      dispatch(ImageListGetAction({ id: BoardId }));
    }
  }, [imageSchedule]);

  useEffect(() => {
    window.addEventListener("resize", HandleResize);
    setScreenData({
      screenHeight: window.innerHeight,
      screenWidth: window.innerWidth,
    });

    return () => {
      window.removeEventListener("resize", HandleResize);
    };
  }, []);

  const HandleResize = () => {
    setScreenData({
      screenHeight: window.innerHeight,
      screenWidth: window.innerWidth,
    });
  };

  const selectBox = (e: any, id: string) => {
    setAllIsOnLock(false);
    setContainerPosition(null);
    setSelectedDivs([]);
    setDataList((prevDataList: any) =>
      prevDataList.map((item: any) => {
        if (item.id === id) {
          return { ...item, selected: true };
        } else {
          return { ...item, selected: false };
        }
      }),
    );
  };

  const selectedClean = useCallback(
    (e: any) => {
      const backgroundElement = document.querySelector(".screen-bg");
      const targetElement = e.target as Element | null;
      if (backgroundElement && targetElement) {
        if (
          (targetElement && targetElement === backgroundElement) ||
          backgroundElement?.className.indexOf("screen-bg") >= 0
        ) {
          const targetType = targetElement.getAttribute(
            "data-interaction-target-type",
          );
          if (targetType && targetType === "screen") {
            document.onmouseup = null;
            document.ontouchend = null;
            document.onmouseup = null;
            document.onmousemove = null;
            if (dataList.length > 0) {
              setDataList((prevDataList: any) =>
                prevDataList.map((item: any) => {
                  return { ...item, selected: false };
                }),
              );
            }
          }
        }
      }
    },
    [dataList],
  );

  const updateWidget = useCallback(
    (data: any) => {
      if ("selected" in data) {
        selectBox("", data.id);
      }
      setEditId(data.id);
      setDataList((prevDataList: any) =>
        prevDataList.map((item: any) => {
          if (item.id === data.id) {
            return {
              ...item,
              listTitle: Object.hasOwnProperty.call(data, "listTitle")
                ? data.listTitle
                : item.listTitle,
              baseHeight: Object.hasOwnProperty.call(data, "baseHeight")
                ? data.baseHeight
                : item.baseHeight,
              height: Object.hasOwnProperty.call(data, "height")
                ? data.height
                : item.height,
              width: Object.hasOwnProperty.call(data, "width")
                ? data.width
                : item.width,
              minHeight: Object.hasOwnProperty.call(data, "minHeight")
                ? data.minHeight
                : item.minHeight,
              minWidth: Object.hasOwnProperty.call(data, "minWidth")
                ? data.minWidth
                : item.minWidth,
              originTop: Object.hasOwnProperty.call(data, "top")
                ? data.top
                : item.originTop,
              originLeft: Object.hasOwnProperty.call(data, "left")
                ? data.left
                : item.originLeft,
              top: Object.hasOwnProperty.call(data, "top")
                ? data.top
                : item.top,
              left: Object.hasOwnProperty.call(data, "left")
                ? data.left
                : item.left,
              zIndex: Object.hasOwnProperty.call(data, "zIndex")
                ? data.zIndex
                : item.zIndex,
              idx: Object.hasOwnProperty.call(data, "idx")
                ? data.idx
                : item.idx,
              spotlight: Object.hasOwnProperty.call(data, "spotlight")
                ? data.spotlight
                : item.spotlight,
              onLock: Object.hasOwnProperty.call(data, "onLock")
                ? data.onLock
                : item.onLock,
              display: Object.hasOwnProperty.call(data, "display")
                ? data.display
                : item.display,
              theme: Object.hasOwnProperty.call(data, "theme")
                ? data.theme
                : item.theme,
              data: Object.hasOwnProperty.call(data, "data")
                ? data.data
                : item.data,
              elementData: Object.hasOwnProperty.call(data, "elementData")
                ? data.elementData
                : item.elementData,
            };
          }
          return item;
        }),
      );

      if (
        teacherUsername ||
        username ===
          dataList.find((item: any) => item.id === data.id)?.studentName
      ) {
        (async () => {
          const response = await socketRequest("updateWidget", {
            trigger: username || teacherUsername,
            boardInfoId: boardInfo.id,
            widget: { ...data },
          });
          // console.log(response);
        })();
      }
    },
    [dataList],
  );

  const itemLock = (id: string, locked: any) => {
    updateWidget({ id: id, onLock: !locked });
    setActionEnd(true);
  };

  const itemUpDown = useCallback(
    async (originId: string, index: number, type: string) => {
      let targetIdx: any;
      let targetZindex: any;
      if (type === "up") {
        targetIdx = dataList.length - 1;
        targetZindex = dataList.length * 2;
      }
      if (type === "down") {
        targetIdx = 0;
        targetZindex = 0;
      }
      if (typeof targetZindex !== "undefined" && targetZindex !== null) {
        const arr = Array.from(dataList);
        const [remove]: any[] = arr.splice(index, 1);
        const newIndex = type === "up" ? dataList.length - 1 : 0;
        arr.splice(newIndex, 0, remove);
        await arr.map(async (item: any, idx: any) => {
          // item.idx = idx;
          item.top = item.originTop;
          item.left = item.originLeft;
          if (type === "up") {
            item.zIndex = idx * 2;
          } else {
            item.zIndex = (idx + 1) * 2;
          }
          if (originId === item.id) {
            item.selected = true;
          } else {
            item.selected = false;
          }
        });
        setDataList(arr);
        setSchedule(arr);
        // setDataList([]);
        // setSchedule([]);
        // setTimeout(() => {
        //   setDataList(arr);
        //   setSchedule(arr);
        // }, 100);
      }
    },
    [dataList],
  );

  const itemUpAll = useCallback(async () => {
    const indexMap = new Map(
      dataList.map((item: any, index: any) => [item.id, index]),
    );
    const selectedIndexes: any[] = selectedDivs
      .map(item => indexMap.get(item.id))
      .filter(index => index !== undefined);
    let newIndex = 1;
    const arr: any = Array.from(dataList);
    const removes: any[] = [];
    const sortedIndexes = selectedIndexes.sort((a, b) => b - a);
    sortedIndexes.forEach(index => {
      if (index >= 0 && index < arr.length) {
        const [remove]: any[] = arr.splice(index, 1);
        removes.push(remove);
      }
    });
    for (let j = 0; j < removes.length; j++) {
      const remove = removes[j];
      arr.splice(dataList.length - newIndex, 0, remove);
      newIndex++;
    }
    await arr.map(async (item: any, index: any) => {
      item.idx = index;
      item.top = item.originTop;
      item.left = item.originLeft;
      item.zIndex = index * 2;
    });
    setDataList(arr);
    ComponentGroupUpdate(arr);
  }, [dataList, selectedDivs]);

  const itemDownAll = useCallback(async () => {
    const indexMap = new Map(
      dataList.map((item: any, index: any) => [item.id, index]),
    );
    const selectedIndexes: any[] = selectedDivs
      .map(item => indexMap.get(item.id))
      .filter(index => index !== undefined);
    let newIndex = 0;
    const arr: any = Array.from(dataList);
    const removes: any[] = [];
    const sortedIndexes = selectedIndexes.sort((a, b) => b - a);
    sortedIndexes.forEach(index => {
      if (index >= 0 && index < arr.length) {
        const [remove]: any[] = arr.splice(index, 1);
        removes.push(remove);
      }
    });
    for (let j = 0; j < removes.length; j++) {
      const remove = removes[j];
      arr.splice(newIndex, 0, remove);
      newIndex++;
    }
    await arr.map(async (item: any, index: any) => {
      item.idx = index;
      item.top = item.originTop;
      item.left = item.originLeft;
      item.zIndex = index * 2;
    });
    setDataList(arr);
    ComponentGroupUpdate(arr);
  }, [dataList, selectedDivs]);

  const toBack = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/user/boards`;
  };

  const layerDisplayChange = useCallback(() => {
    if (layerDisplay) {
      setLayerDisplay(false);
      setDataList((prevDataList: any) =>
        prevDataList.map((item: any) => {
          return { ...item, display: false };
        }),
      );
    } else {
      setLayerDisplay(true);
      setDataList((prevDataList: any) =>
        prevDataList.map((item: any) => {
          return { ...item, display: true };
        }),
      );
    }

    (async () => {
      const response = await socketRequest("changeLayerDisplay", {
        boardInfoId: boardInfo.id,
        display: layerDisplay,
      });
      // console.log(response);
    })();
  }, [dataList]);

  const setDraw = (shapes: any, teacherScreen: any) => {
    // 更新畫筆
    if (boardInfo && draw_id) {
      const draw = JSON.stringify(shapes);
      boardDrawDataUpdate({
        id: draw_id,
        type: "BOARD_DRAW",
        content: JSON.stringify({ draw: draw, teacherScreen: teacherScreen }),
      });
    }
  };

  useEffect(() => {
    if (errorMsg || boardDarwDataUpdateSuccess) {
      if (boardInfo) {
        (async () => {
          // const response = await socketRequest("updateBoard", {
          //   boardInfoIdForDraw: boardInfo.id
          // });
          // console.log(response);
          dispatch(resetboardDarwDataUpdateFlag());
        })();
      }
    }
  }, [dispatch, errorMsg, boardDarwDataUpdateSuccess]);

  const hideDrawboard = useCallback(() => {
    if (!hideDraw && toolSwitch === "draw") {
      setToolSwitch("cursor");
    }
    if (hideDraw) {
      setHideDraw(false);
      setDataList((prevDataList: any) =>
        prevDataList.map((item: any) => {
          if (item.type === "WIDGET_STROKES") {
            return { ...item, display: true };
          }
          return item;
        }),
      );
    } else {
      setHideDraw(true);
      setDataList((prevDataList: any) =>
        prevDataList.map((item: any) => {
          if (item.type === "WIDGET_STROKES") {
            return { ...item, display: false };
          }
          return item;
        }),
      );
    }

    (async () => {
      const response = await socketRequest("changeLayerDisplay", {
        boardInfoId: boardInfo.id,
        display2: hideDraw,
      });
      // console.log(response);
    })();
  }, [dataList]);

  const switchToggle = useCallback(
    (type: string) => {
      if (type === "draw") {
        setHideDraw(false);
      }
      setToolSwitch(type);

      if (dataList.length > 0) {
        setDataList((prevDataList: any) =>
          prevDataList.map((item: any) => {
            return { ...item, selected: false };
          }),
        );
      }
    },
    [dataList],
  );

  const selectCleanForCursor = useCallback(() => {
    if (dataList.length > 0) {
      setDataList((prevDataList: any) =>
        prevDataList.map((item: any) => {
          return { ...item, selected: false };
        }),
      );
    }
  }, [dataList]);

  const jobToggle = (type: string) => {
    setJobType(type);
  };

  const DrawDataSet = (setting: any) => {
    setDrawSetting({
      ...drawSetting,
      ...setting,
    });
  };

  const CoverDataSet = (setting: any) => {
    setCoverSetting({
      ...coverSetting,
      ...setting,
    });
  };

  const handleClear = () => {
    setCanvasClear("clear");
    setTimeout(() => {
      setCanvasClear("");
    }, 100);
  };

  const handleUndo = () => {
    setStepState(`undo${randomNumber(12)}`);
  };

  const handleRedo = () => {
    setStepState(`redo${randomNumber(12)}`);
  };

  //
  useEffect(() => {
    getWorksData();
  }, []);

  const getWorksData = () => {
    dispatch(WorkListGetAction());
    setSelectedList(null);
    setSelectedZone(null);
  };

  const toggleUserErrorModal = () => {
    setShowErrorModal(!showErrorModal);
  };

  useEffect(() => {
    if (errorMsg !== "") {
      Notify.warning(errorMsg);
      setTimeout(() => {
        dispatch(setError(""));
      }, 2000);
    }
  }, [errorMsg]);

  const handleMouseDown = (e: any) => {
    const parentRect: any = parentRef.current?.getBoundingClientRect();
    if (!parentRect) return false;
    if (
      e.target.closest('[data-interaction-target-type="true"]') &&
      e.target
        .closest('[data-interaction-target-type="true"]')
        .getAttribute("data-interaction-target-type")
    )
      return;
    if (
      e.target.closest('[data-interaction-target-type="widget"]') &&
      e.target
        .closest('[data-interaction-target-type="widget"]')
        .getAttribute("data-interaction-target-type") === "widget"
    )
      return;
    setGroupSelect(true);
    const x =
      e.clientX ||
      e.pageX ||
      (e.touches && e.touches[0]?.clientX) ||
      (e.changedTouches && e.changedTouches[0]?.clientX);
    const y =
      e.clientY ||
      e.pageY ||
      (e.touches && e.touches[0]?.clientY) ||
      (e.changedTouches && e.changedTouches[0]?.clientY);
    const parentLeft = parentRect.left || 0;
    const parentTop = parentRect.top || 0;

    const startX = (x - parentLeft) / zoom;
    const startY = (y - parentTop) / zoom;

    selectionBoxRef.current = {
      startX,
      startY,
      x: startX,
      y: startY,
      width: 0,
      height: 0,
    };
    setSelectionBox(selectionBoxRef.current);
    setAllIsOnLock(false);
    setContainerPosition(null);

    const handleMouseMove = (e: any) => {
      if (!parentRect) return false;
      const x =
        e.clientX ||
        e.pageX ||
        (e.touches && e.touches[0]?.clientX) ||
        (e.changedTouches && e.changedTouches[0]?.clientX);
      const y =
        e.clientY ||
        e.pageY ||
        (e.touches && e.touches[0]?.clientY) ||
        (e.changedTouches && e.changedTouches[0]?.clientY);
      const parentLeft = parentRect.left || 0;
      const parentTop = parentRect.top || 0;

      const newX = (x - parentLeft) / zoom;
      const newY = (y - parentTop) / zoom;

      if (selectionBoxRef.current) {
        selectionBoxRef.current = {
          ...selectionBoxRef.current,
          x: Math.min(selectionBoxRef.current.startX, newX),
          y: Math.min(selectionBoxRef.current.startY, newY),
          width: Math.abs(newX - selectionBoxRef.current.startX),
          height: Math.abs(newY - selectionBoxRef.current.startY),
        };
        setSelectionBox(selectionBoxRef.current);
      }
    };

    const handleMouseUp = () => {
      if (!parentRect) return false;
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", handleMouseMove);
      document.removeEventListener("touchend", handleMouseUp);
      const parentLeft = parentRect.left || 0;
      const selectionBox = selectionBoxRef.current;
      if (selectionBox && divRefs.current) {
        const selected = Array.from(divRefs.current.entries())
          .filter(([_, ref]) => {
            if (!ref || typeof ref.getBoundingClientRect !== "function")
              return false;
            const rect = ref.getBoundingClientRect();
            return (
              (rect.left - parentLeft) / zoom <
                selectionBox.x + selectionBox.width &&
              (rect.right - parentLeft) / zoom > selectionBox.x &&
              (rect.top - parentTop) / zoom <
                selectionBox.y + selectionBox.height &&
              (rect.bottom - parentTop) / zoom > selectionBox.y
            );
          })
          .map(([id]) => id);

        const selectedRefs = selected
          .map(id => divRefs.current.get(id))
          .filter(ref => ref !== null) as HTMLDivElement[];

        if (selectedRefs && selectedRefs.length > 0) {
          const bounds = selectedRefs.reduce(
            (acc, ref) => {
              const rect = ref.getBoundingClientRect();
              return {
                top: Math.min(acc.top, rect.top),
                left: Math.min(acc.left, rect.left),
                bottom: Math.max(acc.bottom, rect.bottom),
                right: Math.max(acc.right, rect.right),
              };
            },
            {
              top: Infinity,
              left: Infinity,
              bottom: -Infinity,
              right: -Infinity,
            },
          );

          //
          if (selectedRefs.length === 1) {
            setSelectedDivs([]);
            const results = dataList.filter((itemB: any) =>
              selectedRefs.some((itemA: any) => itemA.id === itemB.id),
            );
            for (let i = 0; i < results.length; i++) {
              updateWidget({ id: results[i].id, selected: true });
            }
          } else {
            setSelectedDivs(selectedRefs);
            setContainerPosition({
              top: (bounds.top - parentTop) / zoom,
              left: (bounds.left - parentLeft) / zoom,
              width: (bounds.right - bounds.left) / zoom,
              height: (bounds.bottom - bounds.top) / zoom,
            });
          }
          let lockCount = 0;
          const selects = dataList.filter((itemB: any) =>
            selectedRefs.some((itemA: any) => itemA.id === itemB.id),
          );
          for (const item of selects) {
            if (item.onLock) {
              lockCount++;
            }
          }
          if (lockCount === selectedRefs.length) {
            setAllIsOnLock(true);
          }
        }
      }

      selectionBoxRef.current = null;
      setSelectionBox(null);
      setGroupSelect(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("touchmove", handleMouseMove);
    document.addEventListener("touchend", handleMouseUp);
  };

  const handleContainerDrag = (e: any) => {
    e.stopPropagation();

    const startX =
      e.clientX ||
      e.pageX ||
      (e.touches && e.touches[0]?.clientX) ||
      (e.changedTouches && e.changedTouches[0]?.clientX);
    const startY =
      e.clientY ||
      e.pageY ||
      (e.touches && e.touches[0]?.clientY) ||
      (e.changedTouches && e.changedTouches[0]?.clientY);

    const initialContainerPosition: any = { ...containerPosition };
    const initialDivPositions = selectedDivs.map(ref => {
      if (ref) {
        const style = window.getComputedStyle(ref);
        return {
          ref,
          top: parseInt(style.top || "0", 10),
          left: parseInt(style.left || "0", 10),
        };
      }
      return null;
    });

    const handleMouseMove = (e: any) => {
      const dx =
        (e.clientX ||
          e.pageX ||
          (e.touches && e.touches[0]?.clientX) ||
          (e.changedTouches && e.changedTouches[0]?.clientX)) - startX;
      const dy =
        (e.clientY ||
          e.pageY ||
          (e.touches && e.touches[0]?.clientY) ||
          (e.changedTouches && e.changedTouches[0]?.clientY)) - startY;

      setContainerPosition(prev =>
        prev
          ? {
              ...prev,
              top: initialContainerPosition.top + dy,
              left: initialContainerPosition.left + dx,
            }
          : null,
      );

      setSelectedDivs(prev =>
        prev.map((_, index) => {
          const divData = initialDivPositions[index];
          if (divData) {
            divData.ref.style.top = `${divData.top + dy}px`;
            divData.ref.style.left = `${divData.left + dx}px`;
          }
          return divData?.ref || null;
        }),
      );
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", handleMouseMove);
      document.removeEventListener("touchend", handleMouseUp);
      setSelectedDivsUpdated(true);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("touchmove", handleMouseMove);
    document.addEventListener("touchend", handleMouseUp);
  };

  const handleContainerResize = (
    e: any,
    direction:
      | "top"
      | "right"
      | "bottom"
      | "left"
      | "top-left"
      | "top-right"
      | "bottom-right"
      | "bottom-left",
  ) => {
    e.stopPropagation();

    const startX =
      e.clientX ||
      e.pageX ||
      (e.touches && e.touches[0]?.clientX) ||
      (e.changedTouches && e.changedTouches[0]?.clientX);
    const startY =
      e.clientY ||
      e.pageY ||
      (e.touches && e.touches[0]?.clientY) ||
      (e.changedTouches && e.changedTouches[0]?.clientY);

    const initialContainerPosition: any = { ...containerPosition };
    const containerStartWidth = initialContainerPosition.width;
    const containerStartHeight = initialContainerPosition.height;
    const containerStartOffsetLeft = initialContainerPosition.left;
    const containerStartOffsetTop = initialContainerPosition.top;

    const initialDivInfo = dataList.filter((itemB: any) =>
      selectedDivs.some((itemA: any) => itemA.id === itemB.id),
    );
    const containerMinHeight = initialDivInfo.reduce(
      (maxMinHeight: number, divData: any) =>
        maxMinHeight > divData.minHeight ? maxMinHeight : divData.minHeight,
      0,
    );
    const containerMinWidth = initialDivInfo.reduce(
      (maxMinWidth: number, divData: any) =>
        maxMinWidth > divData.minWidth ? maxMinWidth : divData.minWidth,
      0,
    );
    // .map((itemB: any) => {
    //   const matchedA = selectedDivs.find((itemA: any) => itemA.id === itemB.id);
    //   return {
    //     ...itemB,
    //     ref: matchedA.ref,
    //   };
    // });

    const handleMouseMove = (e: any) => {
      let containerDx =
        (e.clientX ||
          e.pageX ||
          (e.touches && e.touches[0]?.clientX) ||
          (e.changedTouches && e.changedTouches[0]?.clientX)) - startX;
      let containerDy =
        (e.clientY ||
          e.pageY ||
          (e.touches && e.touches[0]?.clientY) ||
          (e.changedTouches && e.changedTouches[0]?.clientY)) - startY;
      const containerResizeResult = resizeCalculate(
        direction,
        containerStartWidth,
        containerStartHeight,
        containerStartOffsetLeft,
        containerStartOffsetTop,
        containerDx,
        containerDy,
        {
          minHeight: containerMinHeight,
          minWidth: containerMinWidth,
          type: "",
        },
      );

      if (!containerResizeResult) return;
      const containerWidth = containerResizeResult.width;
      const containerHeight = containerResizeResult.height;
      const containerLeft = containerResizeResult.newLeft;
      const containerTop = containerResizeResult.newTop;
      setContainerPosition(prev =>
        prev
          ? {
              ...prev,
              width: containerWidth,
              height: containerHeight,
              left: containerLeft,
              top: containerTop,
            }
          : null,
      );

      if (containerWidth == containerMinWidth)
        containerDx =
          (containerStartWidth - containerMinWidth) *
          (direction.includes("left") ? 1 : -1);
      if (containerHeight == containerMinHeight)
        containerDy =
          (containerStartHeight - containerMinHeight) *
          (direction.includes("top") ? 1 : -1);

      setSelectedDivs(prev =>
        prev.map(selectedDiv => {
          const divData = initialDivInfo.find(
            (data: any) => selectedDiv.id === data.id,
          );
          const startWidth = divData.width;
          const startHeight = divData.height;
          const startOffsetLeft = divData.left;
          const startOffsetTop = divData.top;
          const offsetX = (containerDx * startWidth) / containerStartWidth;
          const offsetY = (containerDy * startHeight) / containerStartHeight;

          const resizeResult = resizeCalculate(
            direction,
            startWidth,
            startHeight,
            startOffsetLeft,
            startOffsetTop,
            offsetX,
            offsetY,
            divData,
          );
          if (resizeResult) {
            const width = resizeResult.width;
            const height = resizeResult.height;
            let left = resizeResult.newLeft;
            let top = resizeResult.newTop;

            if (left < containerLeft) left = containerLeft;
            else if (left + width > containerLeft + containerWidth)
              left = containerLeft + containerWidth - width;
            if (top < containerTop) top = containerTop;
            else if (top + height > containerTop + containerHeight)
              top = containerTop + containerHeight - height;

            selectedDiv.style.width = `${width}px`;
            selectedDiv.style.height = `${height}px`;
            selectedDiv.style.left = `${left}px`;
            selectedDiv.style.top = `${top}px`;

            updateWidget({
              id: divData.id,
              width: width,
              height: height,
              left: left,
              top: top,
            });
          }

          return selectedDiv || null;
        }),
      );
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", handleMouseMove);
      document.removeEventListener("touchend", handleMouseUp);
      setSelectedDivsUpdated(true);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("touchmove", handleMouseMove);
    document.addEventListener("touchend", handleMouseUp);
  };

  useEffect(() => {
    if (selectedDivsUpdated) {
      const results = dataList
        .filter((itemB: any) =>
          selectedDivs.some((itemA: any) => itemA.id === itemB.id),
        )
        .map((itemB: any) => {
          const matchedA = selectedDivs.find(
            (itemA: any) => itemA.id === itemB.id,
          );
          return {
            ...itemB,
            originTop: matchedA?.offsetTop || 0,
            originLeft: matchedA?.offsetLeft || 0,
          };
        });
      for (let i = 0; i < results.length; i++) {
        updateWidget({
          id: results[i].id,
          left: results[i].originLeft,
          top: results[i].originTop,
        });
      }
      ComponentGroupUpdate(results);

      setSelectedDivsUpdated(false);
    }
  }, [selectedDivs, selectedDivsUpdated]);

  const addRef = (id: number, el: HTMLDivElement | null) => {
    if (el) {
      divRefs.current.set(id, el);
    } else {
      divRefs.current.delete(id);
    }
  };

  const copyGroupComponent = useCallback(
    async (items: any, copyCount: any = null) => {
      const API_URL = process.env.REACT_APP_API_URL;
      const updateData = [];
      let count = -1;
      const results = items;
      for (let i = 0; i < results.length; i++) {
        const tempObj = results[i];
        const { elementData, ...content } = tempObj;
        if (username && username !== content?.studentName) {
          return;
        }
        count++;
        content.id = "";
        (content.idx = dataList.length + count),
          (content.zIndex = (dataList.length + count) * 2),
          (content.originTop =
            content?.originTop + 16 * (!copyCount ? pasteCount : copyCount)),
          (content.originLeft =
            content?.originLeft + 16 * (!copyCount ? pasteCount : copyCount)),
          (content.top =
            content?.top + 16 * (!copyCount ? pasteCount : copyCount)),
          (content.left =
            content?.left + 16 * (!copyCount ? pasteCount : copyCount)),
          (content.selected = false);
        if (elementData.type === "WIDGET_STOPWATCH") {
          if (content.width / content.height < 2) {
            content.height = content.height / 2;
            content.baseHeight = 225;
          }
        }
        updateData.push({
          id: "",
          type: elementData.type,
          content: JSON.stringify(content),
        });
      }
      if (updateData.length !== 0) {
        fetch(`${API_URL}/api/updateElementsAll/${boardInfo.id}`, {
          method: "POST",
          headers: {
            userToken: accessToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: updateData,
          }),
        })
          .then(response => response.json())
          .then(data => {
            if (data.status != "SUCCESS") {
              throw data;
            } else {
              setAllIsOnLock(false);
              setContainerPosition(null);
              setSelectedDivs([]);
              elementListGet({
                id: boardInfo.id,
                is_deleted: false,
                is_draw: false,
              });

              (async () => {
                const response = await socketRequest("updateBoard", {
                  boardInfoId: boardInfo.id,
                });
                dispatch(ImageListGetAction({ id: BoardId }));
                // console.log(response);
              })();
            }
          })
          .catch(e => {
            console.log("error", e);

            dispatch(setError("元件更新失敗"));
          });
      }
    },
    [selectedDivs, dataList, pasteCount],
  );

  const removeGroupComponent = useCallback(
    async (e: any) => {
      if (e.button === 2) {
        e.preventDefault();
        return;
      }
      const ids = [];
      const idxs: number[] = [];
      const results = dataList.filter((itemB: any) =>
        selectedDivs.some((itemA: any) => itemA.id === itemB.id),
      );
      for (let i = 0; i < results.length; i++) {
        ids.push(results[i].id);
        idxs.push(results[i].idx);
      }
      const arr = dataList.filter(
        (itemB: any) =>
          !selectedDivs.some((itemA: any) => itemA.id === itemB.id),
      );
      dispatch(BoardElementGroupDeleteAction({ ids: ids }));
      arr.map((item: any, index: number) => {
        return (item.idx = index);
      });
      setAllIsOnLock(false);
      setContainerPosition(null);
      setDataList(arr);
      setSchedule(arr);

      (async () => {
        const response = await socketRequest("deleteComponent", {
          trigger: username || teacherUsername,
          boardInfoId: boardInfo.id,
          id: ids,
        });
        // console.log(response);
      })();
    },
    [selectedDivs, dataList],
  );

  const copyItem = (elm: any) => {
    copyComponent(elm, 1);
    // dispatch(BoardElementListCopyAction({
    //   elements: [elm]
    // }));
  };

  const copyGroupItem = () => {
    if (selectedDivs.length !== 0) {
      const elms = dataList.filter((itemB: any) =>
        selectedDivs.some((itemA: any) => itemA.id === itemB.id),
      );
      console.log("執行多選複製", elms);
      dispatch(
        BoardElementListCopyForNowPageAction({
          elements: elms,
        }),
      );
      copyGroupComponent(elms, 1);
      setPasteThis(true);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // 判斷是否專注在輸入框中
      const activeElement = document.activeElement as HTMLElement | null;
      const isInputFocused =
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          activeElement.isContentEditable);

      // 若專注於輸入框，不進行監控
      if (isInputFocused) {
        console.log("輸入框中按鍵事件被忽略");
        return;
      }
      if (e.key === "Delete" || e.key === "Backspace") {
        e.preventDefault();
        console.log(`Delete 被觸發 - 執行自定義行為: ${boardInfo.id}`);
        if (selectedDivs.length !== 0) {
          const ids = [];
          const idxs: number[] = [];
          const selectedItems = dataList.filter((itemB: any) =>
            selectedDivs.some((itemA: any) => itemA.id === itemB.id),
          );
          console.log("執行多選刪除", selectedItems);
          for (let i = 0; i < selectedItems.length; i++) {
            ids.push(selectedItems[i].id);
            idxs.push(selectedItems[i].idx);
          }
          const arr = dataList.filter(
            (itemB: any) =>
              !selectedDivs.some((itemA: any) => itemA.id === itemB.id),
          );
          dispatch(BoardElementGroupDeleteAction({ ids: ids }));
          arr.map((item: any, index: number) => {
            return (item.idx = index);
          });
          setAllIsOnLock(false);
          setContainerPosition(null);
          setDataList(arr);
          setSchedule(arr);

          (async () => {
            const response = await socketRequest("deleteComponent", {
              trigger: username || teacherUsername,
              boardInfoId: boardInfo.id,
              id: ids,
            });
            // console.log(response);
          })();
        } else {
          const index = dataList.findIndex((item: any) => item.selected);
          if (index !== -1) {
            console.log("執行個別刪除", index);
            const arr = Array.from(dataList);
            const item: any = arr.splice(index, 1);
            dispatch(BoardElementDeleteAction({ id: item[0].id }));
            arr.map((item: any, index: number) => {
              return (item.idx = index);
            });
            setDataList(arr);
            setSchedule(arr);

            (async () => {
              const response = await socketRequest("deleteComponent", {
                trigger: username || teacherUsername,
                boardInfoId: boardInfo.id,
                id: item[0].id,
              });
              // console.log(response);
            })();
          }
        }
      }

      // 檢查是否按下 Ctrl 鍵與 C 鍵
      if ((e.ctrlKey || e.metaKey) && e.key === "c") {
        e.preventDefault(); // 阻止預設行為 (可選)
        console.log(`Ctrl+C 被觸發 - 執行自定義行為: ${boardInfo.id}`);
        if (selectedDivs.length !== 0) {
          const elms = dataList.filter((itemB: any) =>
            selectedDivs.some((itemA: any) => itemA.id === itemB.id),
          );
          console.log("執行多選複製", elms);
          dispatch(
            BoardElementListCopyAction({
              elements: elms,
            }),
          );
        } else {
          const elms = dataList.filter((item: any) => item.selected === true);
          if (elms.length !== 0) {
            console.log("執行個別複製", elms);
            dispatch(
              BoardElementListCopyAction({
                elements: elms,
              }),
            );
          }
        }
        dispatch(setPasteCount(1));
      }

      // 檢查是否按下 Ctrl 鍵與 V 鍵
      if ((e.ctrlKey || e.metaKey) && e.key === "v") {
        e.preventDefault(); // 阻止預設行為 (可選)
        console.log(`Ctrl+V 被觸發 - 執行自定義行為: ${boardInfo.id}`);
        setSelectedDivs([]);
        if (copyStore) {
          const copyData = JSON.parse(copyStore);
          console.log("copyData", copyData);
          if (copyData.length === 1) {
            copyComponent(copyData[0]);
          } else if (copyData.length >= 2) {
            copyGroupComponent(copyData);
            setPasteThis(true);
          }
        }
        dispatch(setPasteCount(pasteCount + 1));
        dispatch(resetBoardElementsCopyFlag());
      }
    };

    // 綁定鍵盤事件
    if (nowPage && canCopy) {
      window.addEventListener("keydown", handleKeyDown);
    } else {
      window.removeEventListener("keydown", handleKeyDown);
    }
    // 清除事件監聽器，避免記憶體洩漏
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [nowPage, canCopy, selectedDivs, dataList, copyStore, pasteThis]);

  const resizePosition = ({ top, left }: { top: number; left: number }) => {
    const ToolWidth =
      (toolRef.current ? toolRef.current.getBoundingClientRect().width : 0) / 2;
    const topBorder = 32;
    const leftBorder = ToolWidth + 16;
    const rightBorder = 1920 - (ToolWidth + 16);
    const bottomBorder = 1080 - 40;
    return {
      top: `calc(${
        top < topBorder ? topBorder : top > bottomBorder ? bottomBorder : top
      }px - 1rem)`,
      left:
        left < leftBorder
          ? leftBorder
          : left > rightBorder
          ? rightBorder
          : left,
    };
  };

  const onLockAll = () => {
    const selectedItems = dataList.filter((itemB: any) =>
      selectedDivs.some((itemA: any) => itemA.id === itemB.id),
    );
    if (AllIsOnLock) {
      for (let i = 0; i < selectedItems.length; i++) {
        selectedItems[i].onLock = false;
        updateWidget({ id: selectedItems[i].id, onLock: false });
      }
      ComponentGroupUpdate(selectedItems);
      setAllIsOnLock(false);
    } else {
      for (let i = 0; i < selectedItems.length; i++) {
        selectedItems[i].onLock = true;
        updateWidget({ id: selectedItems[i].id, onLock: true });
      }
      ComponentGroupUpdate(selectedItems);
      setAllIsOnLock(true);
    }
  };

  const BASE_URL = `${process.env.REACT_APP_API_URL}/elements/image/`;
  const sideContainer = false;

  useEffect(() => {
    setBoardElementStore(prev => {
      const next = { ...prev };
      for (const el of dataList) {
        const id = String(el.id);
        if (!(id in next)) next[id] = true; // 預設顯示；要預設隱藏就改 false
      }
      return next;

      // 若想同時「移除不再存在的 id」，改成：
      // const alive = new Set(newArr.map(el => String(el.id)));
      // for (const k of Object.keys(next)) if (!alive.has(k)) delete next[k];
      // return next;
    });
  }, [dataList]);

  const recolorBase64Png = (
    srcDataUrl: string,
    color: string,
  ): Promise<string> => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous"; // 保守處理，同源時不影響
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d")!;

        // 先把原圖畫上去
        ctx.drawImage(img, 0, 0);
        // 只在已畫過的像素（原圖不透明處）上著色
        ctx.globalCompositeOperation = "source-in";
        ctx.fillStyle = color; // e.g. "#00AEEF" 或 "rgb(0,174,239)"
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        // 取回新的 data URL
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
      img.src = srcDataUrl;
    });
  };

  return (
    <React.Fragment>
      {/*  */}
      <Modal
        id="errorModal"
        className="h-100 w-100 items-center justify-center sm:p-14 m-auto"
        isOpen={showErrorModal}
        toggle={toggleUserErrorModal}
        modalClassName="zoomIn"
        zIndex={1000120}
        autoFocus={false}
        centered
      >
        <div className="relative rounded-lg bg-white text-left shadow-xl overflow-y-auto overflow-x-hidden max-h-full w-full max-w-xs sm:max-w-3xl md:max-w-5xl">
          <div className="error-box">
            <div className="error-icon">
              <i className="ri-alert-line fs-120"></i>
            </div>
            <div className="error-msg">{errorMsg}</div>
            <div className="error-btn">
              <Button
                className="rounded-pill"
                variant="contained"
                onClick={() => {
                  toggleUserErrorModal();
                  setTimeout(() => {
                    dispatch(setError(""));
                  }, 1500);
                }}
              >
                確定
              </Button>
            </div>
          </div>
        </div>
      </Modal>
      {/*  */}
      {screenData.screenWidth > 500 ? (
        <Tooltip anchorSelect=".feature-anchor" place="top" />
      ) : (
        <Tooltip anchorSelect=".feature-anchor" place="bottom" />
      )}
      <div
        className="screen-board-base"
        style={{
          height: screenData.screenHeight,
          width: screenData.screenWidth,
        }}
      >
        <div
          className="screen-board-base-inner"
          style={{
            height: screenData.screenHeight,
            width: screenData.screenWidth,
          }}
        >
          <div ref={parentRef} style={{ position: "relative" }}>
            <div
              className={`screen-group  ${
                toolSwitch === "draw" && jobType === "eraser"
                  ? "cursor-eraser"
                  : ""
              }`}
              style={{ height: 1080, width: 1920, zoom: zoom }}
              data-a={toolSwitch}
              data-b={jobType}
            >
              <div
                className="relative top-0 start-0 overflow-hidden"
                style={{ height: 1080, width: 1920 }}
              >
                <div
                  className="absolute top-0 start-0 overflow-hidden"
                  style={{ height: 1080, width: 1920 }}
                >
                  <div
                    className="absolute top-0 left-0 overflow-hidden z-1"
                    style={{ height: 1080, width: 1920 }}
                  >
                    <div
                      className="relative overflow-hidden"
                      style={{ height: 1080, width: 1920 }}
                    >
                      <div className="bg-white absolute -inset-px overflow-hidden z-1"></div>
                      <div
                        className="teachSay-bg absolute top-0 start-0 overflow-hidden z-3"
                        style={{
                          height: 1080,
                          width: 1920,
                          backgroundImage: `url("${
                            BASE_URL + boardInfo?.backgroundInfo.picture
                          }")`,
                        }}
                      ></div>
                      <div
                        className="spotlightBackground"
                        style={{ height: 1080, width: 1920, zIndex: 1000114 }}
                      ></div>
                      <div className="absolute -inset-px overflow-hidden z-5"></div>
                    </div>
                  </div>
                  <div
                    className={`screen-bg absolute top-0 left-0 overflow-hidden z-3`}
                    style={{ height: 1080, width: 1920 }}
                    onPointerDown={(e: any) => {
                      selectedClean(e);
                      if (teacherUsername) {
                        handleMouseDown(e);
                      }
                    }}
                    onDragStart={e => e.preventDefault()}
                    data-interaction-target-type="screen"
                  >
                    <div className="absolute top-0 left-0 touch-none">
                      <div
                        className="screen-bg"
                        onPointerDown={selectedClean}
                        onDragStart={e => e.preventDefault()}
                        data-interaction-target-type="screen"
                      >
                        {nowPage && selectionBox && (
                          <div
                            style={{
                              position: "absolute",
                              top: selectionBox.y,
                              left: selectionBox.x,
                              width: selectionBox.width,
                              height: selectionBox.height,
                              border: "1px solid blue",
                              backgroundColor: "rgba(0, 0, 255, 0.1)",
                              pointerEvents: "none",
                              transformOrigin: "left top",
                              zIndex: 100000,
                            }}
                          />
                        )}

                        {nowPage && containerPosition && (
                          <>
                            <div
                              ref={containerRef}
                              className="resize-handle"
                              style={{
                                position: "absolute",
                                top: `${containerPosition.top}px`,
                                left: `${containerPosition.left}px`,
                                width: `${containerPosition.width}px`,
                                height: `${containerPosition.height}px`,
                                border: `${2 / zoom}px dashed #91e2ca`,
                                borderRadius: "0.5rem",
                                zIndex: 100001,
                                cursor: "pointer",
                              }}
                              onPointerDown={handleContainerDrag}
                              data-interaction-target-type={true}
                            >
                              <>
                                <div
                                  data-side="top"
                                  className={`${
                                    sideContainer ? "sideBtn" : ""
                                  }`}
                                  data-interaction-target-type={true}
                                >
                                  <div
                                    className="side-resize-btn"
                                    onPointerDown={e =>
                                      handleContainerResize(e, "top")
                                    }
                                    data-interaction-target-type="widget"
                                    data-interaction-ignore-drag="false"
                                  ></div>
                                </div>
                                <div
                                  data-side="bottom"
                                  className={`${
                                    sideContainer ? "sideBtn" : ""
                                  }`}
                                  data-interaction-target-type={true}
                                >
                                  <div
                                    className="side-resize-btn"
                                    onPointerDown={e =>
                                      handleContainerResize(e, "bottom")
                                    }
                                    data-interaction-target-type="widget"
                                    data-interaction-ignore-drag="false"
                                  ></div>
                                </div>
                                <div
                                  data-side="left"
                                  className={`${
                                    sideContainer ? "sideBtn" : ""
                                  }`}
                                  data-interaction-target-type={true}
                                >
                                  <div
                                    className="side-resize-btn"
                                    onPointerDown={e =>
                                      handleContainerResize(e, "left")
                                    }
                                    data-interaction-target-type="widget"
                                    data-interaction-ignore-drag="false"
                                  ></div>
                                </div>
                                <div
                                  data-side="right"
                                  className={`${
                                    sideContainer ? "sideBtn" : ""
                                  }`}
                                  data-interaction-target-type={true}
                                >
                                  <div
                                    className="side-resize-btn"
                                    onPointerDown={e =>
                                      handleContainerResize(e, "right")
                                    }
                                    data-interaction-target-type="widget"
                                    data-interaction-ignore-drag="false"
                                  ></div>
                                </div>

                                <div
                                  onPointerDown={e =>
                                    handleContainerResize(e, "top-right")
                                  }
                                  data-interaction-target-type="widget"
                                  data-interaction-ignore-drag="false"
                                ></div>
                                <div
                                  onPointerDown={e =>
                                    handleContainerResize(e, "bottom-right")
                                  }
                                  data-interaction-target-type="widget"
                                  data-interaction-ignore-drag="false"
                                ></div>
                                <div
                                  onPointerDown={e =>
                                    handleContainerResize(e, "bottom-left")
                                  }
                                  data-interaction-target-type="widget"
                                  data-interaction-ignore-drag="false"
                                ></div>
                                <div
                                  onPointerDown={e =>
                                    handleContainerResize(e, "top-left")
                                  }
                                  data-interaction-target-type="widget"
                                  data-interaction-ignore-drag="false"
                                ></div>
                              </>
                            </div>
                            <div
                              ref={toolRef}
                              className="itemToolbar absolute"
                              style={{
                                ...resizePosition({
                                  top:
                                    (containerPosition.top
                                      ? containerPosition.top
                                      : 0) - 43,
                                  left:
                                    (containerPosition.left
                                      ? containerPosition.left
                                      : 0) +
                                    (containerPosition.width
                                      ? containerPosition.width
                                      : 0) /
                                      2,
                                }),
                                zIndex: 100002,
                                transform: `translateX(-50%) scale(${
                                  1 / zoom
                                })`,
                              }}
                              data-interaction-ignore-drag={false}
                              data-interaction-target-type={true}
                            >
                              <div className="ts-toolBar">
                                {teacherUsername ? (
                                  <div
                                    className="ts-btn ts-btnGroup"
                                    onPointerDown={onLockAll}
                                  >
                                    <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                                      <img
                                        src={lock}
                                        alt=""
                                        style={{
                                          height: "auto",
                                          width: "16px",
                                          opacity: AllIsOnLock ? 1 : 0.6,
                                        }}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                                <div
                                  className="ts-btn ts-btnGroup"
                                  onPointerDown={copyGroupItem}
                                >
                                  <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                                    <img
                                      src={item_copy}
                                      alt=""
                                      style={{ width: "18px" }}
                                    />
                                  </div>
                                </div>
                                {teacherUsername ? (
                                  <div
                                    className="ts-btn ts-btnGroup"
                                    onPointerDown={itemUpAll}
                                  >
                                    <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                                      <img
                                        src={toTop}
                                        alt=""
                                        style={{
                                          height: "auto",
                                          width: "18px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                                {teacherUsername ? (
                                  <div
                                    className="ts-btn ts-btnGroup"
                                    onPointerDown={itemDownAll}
                                  >
                                    <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                                      <img
                                        src={toBottom}
                                        alt=""
                                        style={{
                                          height: "auto",
                                          width: "18px",
                                        }}
                                      />
                                    </div>
                                  </div>
                                ) : null}
                                <div className="ts-gap ts-btnGroup"></div>
                                <div
                                  className={`ts-btn ts-btnGroup`}
                                  onPointerDown={(e: any) => {
                                    removeGroupComponent(e);
                                  }}
                                >
                                  <div className="relative flex h-100 w-100 flex-row items-center justify-center">
                                    <img src={lightDelete} alt="" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {(dataList || []).map((item: any, index: any) => (
                          <BaseBlock
                            key={item.id}
                            localRef={(el: any) => addRef(item.id, el)}
                            selfDisplay={boardElementStore[item.id]}
                            data={item}
                            itemIndex={index}
                            screenData={screenData}
                            nowPage={nowPage}
                            scale={zoom}
                            status={ScaleStatus}
                            selected={item.selected}
                            groupSelect={groupSelect}
                            onSelect={selectBox}
                            onRemove={removeComponent}
                            onUpdate={updateWidget}
                            actionEnd={setActionEnd}
                            onLock={itemLock}
                            onUpDown={itemUpDown}
                            selectedList={selectedList}
                            selectedZone={selectedZone}
                            setSelectedList={setSelectedList}
                            setSelectedZone={setSelectedZone}
                            getWorksData={getWorksData}
                            setImageSchedule={setImageSchedule}
                            setImageScheduleCount={setImageScheduleCount}
                            setEditId={setEditId}
                            callUpdateBoard={callUpdateBoard}
                            copyItem={copyItem}
                            toolSwitch={toolSwitch}
                            jobType={jobType}
                            userPermission={UserPermission}
                            setCanCopy={setCanCopy}
                            socketRequest={socketRequest}
                            boardInfoId={boardInfo.id}
                            holdThisBox={holdThisBox}
                            setHoldThisBox={setHoldThisBox}
                            hoverCard={hoverCard}
                            drawSetting={drawSetting}
                            setCursorItem={setCursorItem}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                {nowPage && teacherUsername ? (
                  <BackgroundModule
                    id={BoardId}
                    showModal={showModal}
                    toggleModal={toggleModal}
                  />
                ) : null}
                <div
                  className="screen-cover z-5"
                  style={{ height: 1080, width: 1920 }}
                >
                  <div style={{ height: 1080, width: 1920 }}></div>
                </div>

                {toolSwitch === "searchlight" ? (
                  <Mask
                    zoom={zoom}
                    socketRequest={socketRequest}
                    holePercent={spotlightSize} // 0~100：長條的高度百分比（相對容器高度）
                    settings={{ ...coverSetting }} // 你原本的設定
                    shape={coverSetting.type} // ← 新增，'circle' | 'strip' | 'square'（預設 circle）
                    stripPivot="top" // ← 可選 'center' | 'top' | 'bottom'（預設 center）
                    actorId={teacherUsername}
                  />
                ) : null}
                {username && userCoverSetting.tool === "searchlight" ? (
                  <MaskUser settings={userCoverSetting} />
                ) : null}
              </div>
            </div>
            {nowPage ? (
              <DrawingTool
                stepState={stepState}
                canvasClear={canvasClear}
                addDraw={addDrawComponent}
                drawData={drawData}
                setDraw={setDraw}
                toolSwitch={toolSwitch}
                jobType={jobType}
                drawSetting={drawSetting}
                scale={zoom}
                hideDraw={hideDraw}
                selectionBoxRef={selectionBoxRef}
                setSelectionBox={setSelectionBox}
                setGroupSelect={setGroupSelect}
                setAllIsOnLock={setAllIsOnLock}
                setContainerPosition={setContainerPosition}
                nowPage={nowPage}
              />
            ) : null}
          </div>
        </div>
      </div>

      {nowPage && boardElementsCopySuccess ? (
        <div className="pasteMsg">
          <div
            className="pasteText"
            onClick={() => {
              setSelectedDivs([]);
              if (copyStore) {
                const copyData = JSON.parse(copyStore);
                console.log("copyData", copyData);
                if (copyData.length === 1) {
                  copyComponent(copyData[0]);
                } else if (copyData.length >= 2) {
                  copyGroupComponent(copyData);
                  setPasteThis(true);
                }
              }
              dispatch(setPasteCount(pasteCount + 1));
              dispatch(resetBoardElementsCopyFlag());
            }}
          >
            <img src={item_copy} alt="" style={{ width: "18px" }} />
            <span>
              貼上元件<span>Ctrl V</span>
            </span>
          </div>
          <div className="pastegap"></div>
          <div
            className="pasteBtn"
            onClick={() => {
              dispatch(resetBoardElementsCopyFlag());
            }}
          >
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                {/* <!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--> */}
                <path
                  fill="#5d5b53"
                  d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                />
              </svg>
            </div>
          </div>
        </div>
      ) : null}

      {(nowPage && teacherUsername) ||
      (nowPage && username && UserPermission) ? (
        <BottomToolbar
          toolSwitch={toolSwitch}
          switchToggle={switchToggle}
          jobToggle={jobToggle}
          drawSetting={drawSetting}
          DrawDataSet={DrawDataSet}
          undo={handleUndo}
          redo={handleRedo}
          clear={handleClear}
          dataList={dataList}
          username={username}
          teacherUsername={teacherUsername}
          userPermission={UserPermission}
          addBlock={addBlock}
          setAddBlock={setAddBlock}
          addComponent={addComponent}
          toggleModal={toggleModal}
          screenData={screenData}
          selectionBoxRef={selectionBoxRef}
          setSelectionBox={setSelectionBox}
          setGroupSelect={setGroupSelect}
          setAllIsOnLock={setAllIsOnLock}
          setContainerPosition={setContainerPosition}
          coverSetting={coverSetting}
          CoverDataSet={CoverDataSet}
          receive={receive}
          handleReceive={handleReceive}
          toolScale={toolScale}
          spotlightSize={spotlightSize}
          setSpotlightSize={setSpotlightSize}
          cursorSetColor={cursorSetColor}
          selectCleanForCursor={selectCleanForCursor}
          socketRequest={socketRequest}
        />
      ) : null}
      {nowPage ? (
        <>
          {teacherUsername ? (
            <div
              className="left-tool-box"
              style={{ transform: `scale(${toolScale}) translateY(-50%)` }}
            >
              {leftToolShow ? (
                <div className="show-box">
                  <div
                    className="tool-close-btn"
                    onClick={() => {
                      setLeftToolShow(false);
                    }}
                  >
                    <img src={leftToolClose} alt="" />
                  </div>
                  <div className="tool-body">
                    <button
                      className="feature-anchor top-tool-btn"
                      onClick={toBack}
                      data-tooltip-content="首頁"
                    >
                      <img src={btnHome} alt="" />
                    </button>
                    <UsersTool
                      data={userList}
                      setData={setUserList}
                      allPermissionSet={allPermissionSet}
                      userPermissionSet={userPermissionSet}
                      PermissionControl={PermissionControl}
                      setPermissionControl={setPermissionControl}
                      showUserModal={showUserModal}
                      toggleUserModal={toggleUserModal}
                      toggleBoardShareModal={toggleBoardShareModal}
                    />
                    <UserSettings />
                  </div>
                </div>
              ) : null}
              {!leftToolShow ? (
                <div
                  className="hide-box"
                  onClick={() => {
                    setLeftToolShow(true);
                  }}
                >
                  <img src={leftToolOpen} alt="" />
                </div>
              ) : null}
            </div>
          ) : null}
          {teacherUsername ? (
            <div
              className="right-tool-box"
              style={{ transform: `scale(${toolScale}) translateY(-50%)` }}
            >
              {rightToolShow ? (
                <div className="show-box">
                  <div
                    className="tool-close-btn"
                    onClick={() => {
                      setRightToolShow(false);
                    }}
                  >
                    <img src={rightToolClose} alt="" />
                  </div>
                  <div className="tool-body">
                    <LayerTool
                      data={dataList}
                      setData={setDataList}
                      layerDisplay={layerDisplay}
                      boardElementStore={boardElementStore}
                      setVisibilityByIds={setVisibilityByIds}
                      onUpdate={updateWidget}
                      showLayerModal={showLayerModal}
                      toggleLayerModal={toggleLayerModal}
                      setSchedule={setSchedule}
                      setLayerUpdateLoad={setLayerUpdateLoad}
                      selectedDivs={selectedDivs}
                    />
                    <ElementHide
                      data={dataList}
                      ComponentDisplay={ComponentDisplay}
                      StrokeDisplay={StrokeDisplay}
                      setVisibilityByType={setVisibilityByType}
                      setDataList={setDataList}
                      setSchedule={setSchedule}
                    />
                    <RecycleBin
                      id={BoardId}
                      accessToken={accessToken}
                      dataList={dataList}
                      elementListGet={elementListGet}
                    />
                  </div>
                </div>
              ) : null}
              {!rightToolShow ? (
                <div
                  className="hide-box"
                  onClick={() => {
                    setRightToolShow(true);
                  }}
                >
                  <img src={rightToolOpen} alt="" />
                </div>
              ) : null}
            </div>
          ) : null}

          <FullScreen
            screenMode={isFullScreenMode}
            setScreenMode={setIsFullScreenMode}
            user={username}
            toolScale={toolScale}
          />
          {teacherUsername ? (
            <BoardList
              id={BoardId}
              accessToken={accessToken}
              dataList={dataList}
              screenMode={isFullScreenMode}
              setScreenMode={setIsFullScreenMode}
              showSettingModal={showSettingModal}
              toggleSettingModal={toggleSettingModal}
              showPageModal={showPageModal}
              togglePageModal={togglePageModal}
              setBoardSchedule={setBoardSchedule}
              setPageUpdateLoad={setPageUpdateLoad}
              pageToThis={pageToThis}
              setSocketReset={setSocketReset}
              setChangePage={setChangePage}
              boardItem={boardInfo}
              elementListGet={elementListGet}
              toolScale={toolScale}
            />
          ) : null}
        </>
      ) : null}

      {/*  */}
      <Modal
        id="shareModal"
        className="h-100 w-100 items-center justify-center sm:p-14 m-auto"
        isOpen={boardShare}
        toggle={toggleBoardShareModal}
        modalClassName="zoomIn"
        zIndex={1000120}
        centered
      >
        <div className="relative bg-screen text-left shadow-xl overflow-y-auto overflow-x-hidden max-h-full w-full">
          <div>
            <div className="setting-box w-100">
              <div className="basis-1/2 lg:basis-3/5 xl:basis-2/3">
                <input
                  id="share"
                  name="share"
                  type="text"
                  className="crs-text-input mt-2"
                  readOnly
                  value={`${process.env.REACT_APP_API_URL}/myBoard/${BoardId}`}
                />
                <div className="mt-3">
                  <Button
                    type="button"
                    className="rounded-pill student-btn"
                    variant="contained"
                    onClick={() => {
                      handleCopy(
                        `${process.env.REACT_APP_API_URL}/myBoard/${BoardId}`,
                      );
                    }}
                  >
                    複製
                  </Button>
                </div>
                <div className="mt-4 d-flex justify-center">
                  <QRCode
                    className="share-code"
                    value={`${process.env.REACT_APP_API_URL}/myBoard/${BoardId}`}
                    size={256}
                    level={"L"}
                    bgColor={"#efefef"}
                    fgColor={"#5d5b53"}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/*  */}
    </React.Fragment>
  );
};

export default memo(BoardPage);
